import { useHistory, useParams, withRouter } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import "./noteBookListOutline.css";
import Spinner from "../Spinner/Spinner";
import { Button } from "react-bootstrap";
import { GrFormClose } from "react-icons/gr";
import Popover from "react-bootstrap/Popover";
import Dialog from "@material-ui/core/Dialog";
import { AiOutlineUnderline } from "react-icons/ai";
import { handleException } from "../../app/util/util";
import shareLinkIcon from "../Ebook/shareLinkIcon.png";
import { useSelector, useDispatch } from "react-redux";
import loaderColors1 from "../Spinner/loaderColors1.gif";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DialogContentText from "@material-ui/core/DialogContentText";
import {
  setLabelSettingsVOList,
  setReduxAnnotationVO,
} from "../../app/redux/UserSlice";
export function NoteBookListOutline(props) {
  let colorCodeListOutline1 = [],
    userVO1 = "",
    linkShareFlagStatus1 = "";
  let noteFlagDelete = false,
    timeCount = "",
    updatingBrief = false,
    addingBrief = false;
  userVO1 = JSON.parse(localStorage.getItem("userVO"));
  const { bookVO, userVO, chapterId } = props;
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const selector = useSelector((e) => e.userVO);
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const onHandlesetReduxAnnotationVO = (annotatio) =>
    dispatch(setReduxAnnotationVO(annotatio));
  const onHandleSetLabelSettingsVOList = (labelSettingsVOList) =>
    dispatch(setLabelSettingsVOList(labelSettingsVOList));
  const outlineId = useRef("");
  const noteEdit = useRef(false);
  const outLineProfUrl = useRef("");
  const outLineNoteValue = useRef("");
  const [loading, setLoading] = useState(false);
  const [noteStatus, setNoteStatus] = useState(false);
  const [sectionVOList, setSectionVOList] = useState(
    props.sectionVOList ? props.sectionVOList : [],
  );
  const [isSharedLink, setIsSharedLink] = useState(false);
  const [routeChangeMsg, setRouteChangeMsg] = useState("");
  const [state, setState] = useState({ chapterId: chapterId });
  const [outlineColorList, setOutlineColorList] = useState([]);
  const [chapterDrpDwnList, setChapterDrpDwnList] = useState([]);
  const [briefNoteLoading, setBriefNoteLoading] = useState(false);
  const [annotationSectionId, setAnnotationSectionId] = useState("");
  const [currentState, setCurrentState] = useState({
    currentChapterId: chapterId,
    currentChapterNavTitle: "",
  });
  const [notificationsState, setNotificationState] = useState({
    notificationOpen: false,
    notificationContent: "",
  });
  const [colorsState, setColorsState] = useState({
    colorYellow: false,
    colorGreen: false,
    colorBlue: false,
    colorPink: false,
    colorOrange: false,
    colorPurple: false,
    colorCyan: false,
    colorLightNavy: false,
    colorLightCoral: false,
    colorSandrift: false,
    colorGainsboro: false,
    highlightQuickUnderLine: false,
  });
  const getLatestColors = async () => {
    let colorCodeListOutline = [
      {
        id: "color-yellowOut",
        title: "Yellow",
        color: "#EDE48C",
        colorCode: "#EDE48C",
        stateValue: "colorYellow",
      },
      {
        id: "color-greenOut",
        title: "Green",
        color: "#B5EB97",
        colorCode: "#B5EB97",
        stateValue: "colorGreen",
      },
      {
        id: "color-blueOut",
        title: "Blue",
        color: "#AEE6FE",
        colorCode: "#AEE6FE",
        stateValue: "colorBlue",
      },
      {
        id: "color-pinkOut",
        title: "Pink",
        color: "#FEC0FF",
        colorCode: "#FEC0FF",
        stateValue: "colorPink",
      },
      {
        id: "color-orangeOut",
        title: "Orange",
        color: "#FFD4A8",
        colorCode: "#FFD4A8",
        stateValue: "colorOrange",
      },
      {
        id: "color-purpleOut",
        title: "Purple",
        color: "#CBBEFC",
        colorCode: "#CBBEFC",
        stateValue: "colorPurple",
      },
      {
        id: "color-cyan",
        title: "Cyan",
        color: "#35FBE2",
        colorCode: "#35FBE2",
        stateValue: "colorCyan",
      },
      {
        id: "color-lightNavyOut",
        title: "LightNavy",
        color: "#95A7FF",
        colorCode: "#95A7FF",
        stateValue: "colorLightNavy",
      },
      {
        id: "color-lightCoralOut",
        title: "LightCoral",
        color: "#FF8787",
        colorCode: "#FF8787",
        stateValue: "colorLightCoral",
      },
      {
        id: "color-sandriftOut",
        title: "Sandrift",
        color: "#C1A88E",
        colorCode: "#C1A88E",
        stateValue: "colorSandrift",
      },
      {
        id: "color-gainsboroOut",
        title: "Gainsboro",
        color: "#DADADA",
        colorCode: "#DADADA",
        stateValue: "colorGainsboro",
      },
      {
        id: "underLineOut",
        title: "underLine",
        color: "underLine",
        colorCode: "underLine",
        stateValue: "highlightQuickUnderLine",
      },
    ];
    colorCodeListOutline1 = [];
    let hiddenColorCodesOutline = selector.removedColorsVOList;
    if (hiddenColorCodesOutline !== null) {
      hiddenColorCodesOutline.forEach((i) => {
        colorCodeListOutline.splice(
          colorCodeListOutline.findIndex(
            (item) => item.color === i.highlightColorCode,
          ),
          1,
        );
      });
    }
    colorCodeListOutline1 = [...colorCodeListOutline];
    setOutlineColorList(colorCodeListOutline1);
  };
  useEffect(() => {
    const handleFetchDataFromApi = async () => {
      await getLatestColors();
      await getChapterListForOutline();
      let briefLabelVOList = Array.isArray(props.labelVOList)
        ? props.labelVOList
        : [props.labelVOList];
      onHandleSetLabelSettingsVOList(briefLabelVOList);
    };
    handleFetchDataFromApi();
  }, []);
  useEffect(() => {
    getChapterLayout(currentState.currentChapterId);
  }, [currentState.currentChapterId]);
  useEffect(() => {
    if (selector.reduxAnnotationVO && selector.reduxAnnotationVO.annotationStatus) {
      const changedChapterId =
        selector.reduxAnnotationVO.chapterId || currentState.currentChapterId;

      // Annotation/highlight data changed. Do not reuse an older cached
      // outline for this chapter, otherwise the right-side Outline can show
      // stale data after navigating away and coming back.
      if (changedChapterId && chapterCache.current[changedChapterId]) {
        delete chapterCache.current[changedChapterId];
      }
    }

    updateHighlights();
  }, [selector.reduxAnnotationVO]);
  useEffect(() => {}, [selector.removedColorsVOList]);
  const updateHighlights = () => {
    let auxSectionVOList = sectionVOList;
    let sectionVO = auxSectionVOList.filter(
      (x) => x.sectionId === selector.reduxAnnotationVO.sectionId,
    )[0];
    if (
      selector.reduxAnnotationVO &&
      selector.reduxAnnotationVO.annotationStatus &&
      selector.reduxAnnotationVO.annotationStatus === "added"
    ) {
      if (sectionVO) {
        if (navigator.onLine) {
          getChapterLayout(currentState.currentChapterId);
        } else if (sectionVO.annotationVOList) {
          let annotationVOList = Array.isArray(sectionVO.annotationVOList)
            ? sectionVO.annotationVOList
            : [sectionVO.annotationVOList];
          const currentItem = selector.reduxAnnotationVO;
          annotationVOList.push(currentItem);
          const annotationVOListBrief = annotationVOList
            .filter((x) => x.dppContentType === "brief")
            .sort(
              (a, b) =>
                parseFloat(a.highlightStartOffset) -
                parseFloat(b.highlightStartOffset),
            );
          const annotationVOListannotation = annotationVOList
            .filter((x) => x.dppContentType === "annotation")
            .sort(
              (a, b) =>
                parseFloat(a.highlightStartOffset) -
                parseFloat(b.highlightStartOffset),
            );
          for (var i = 0; i < auxSectionVOList.length; i++) {
            if (auxSectionVOList[i].sectionId === sectionVO.sectionId) {
              auxSectionVOList[i].annotationVOList = [
                ...annotationVOListBrief,
                ...annotationVOListannotation,
              ];
            }
          }
          setSectionVOList(auxSectionVOList);
          noteEdit.current = false;
          setLoading(false);
        } else {
          getChapterLayout(currentState.currentChapterId);
        }
      } else {
        getChapterLayout(currentState.currentChapterId);
      }
    } else if (
      selector.reduxAnnotationVO &&
      selector.reduxAnnotationVO.annotationStatus &&
      (selector.reduxAnnotationVO.annotationStatus === "updated" ||
        selector.reduxAnnotationVO.annotationStatus === "updatedNote" ||
        selector.reduxAnnotationVO.annotationStatus === "updatedLink")
    ) {
      if (sectionVO) {
        if (sectionVO.annotationVOList) {
          let annotationVOList = Array.isArray(sectionVO.annotationVOList)
              ? sectionVO.annotationVOList
              : [sectionVO.annotationVOList],
            newAnnotationVOList = [];
          annotationVOList.filter(
            (x) =>
              x.highlightStartParaId ===
              selector.reduxAnnotationVO.highlightStartParaId,
          );
          const temArray = [...annotationVOList];
          localStorage.setItem("updatededAnotationFromOutlines", true);
          for (var i = 0; i < temArray.length; i++) {
            if (
              temArray[i].annotationId ===
              selector.reduxAnnotationVO.annotationId
            ) {
              if (selector.reduxAnnotationVO.annotationStatus === "updated") {
                var temp = JSON.parse(JSON.stringify(temArray[i]));
                temp.highlightColorCode =
                  selector.reduxAnnotationVO.highlightColorCode;
                newAnnotationVOList.push(temp);
              }
              if (
                selector.reduxAnnotationVO.annotationStatus === "updatedNote"
              ) {
                var temp = JSON.parse(JSON.stringify(temArray[i]));
                temp.noteText = selector.reduxAnnotationVO.noteText;
                newAnnotationVOList.push(temp);
              } else if (
                selector.reduxAnnotationVO.annotationStatus === "updatedLink"
              ) {
                var temp = JSON.parse(JSON.stringify(temArray[i]));
                temp.linkUrl = selector.reduxAnnotationVO.linkUrl;
                temp.linkShareFlag = selector.reduxAnnotationVO.linkShareFlag;
                temp.linkDescription =
                  selector.reduxAnnotationVO.linkDescription;
                newAnnotationVOList.push(temp);
              } else newAnnotationVOList.push(selector.reduxAnnotationVO);
            } else {
              newAnnotationVOList.push(temArray[i]);
            }
          }
          newAnnotationVOList = newAnnotationVOList.filter(
            (thing, index, self) =>
              index ===
              self.findIndex((t) => t.annotationId === thing.annotationId),
          );
          for (var i = 0; i < auxSectionVOList.length; i++) {
            if (auxSectionVOList[i].sectionId === sectionVO.sectionId) {
              auxSectionVOList[i].annotationVOList = newAnnotationVOList;
            }
          }
          noteEdit.current = false;
          setSectionVOList(auxSectionVOList);
          setLoading(false);
        }
        if (selector.reduxAnnotationVO.annotationStatus === "updatedNote") {
          if (
            document.getElementById(
              "outline_" + selector.reduxAnnotationVO.annotationId,
            ) &&
            document
              .getElementById(
                "outline_" + selector.reduxAnnotationVO.annotationId,
              )
              .querySelector(".outline_noteText")
          )
            document
              .getElementById(
                "outline_" + selector.reduxAnnotationVO.annotationId,
              )
              .querySelector(".outline_noteText").textContent =
              selector.reduxAnnotationVO.noteText;
        }
        const elements = document.querySelectorAll(
          ".annotatedOutlineHighlightCont",
        );
        elements.forEach((element) => {
          if (element.id.includes(selector.reduxAnnotationVO.annotationId)) {
            if (selector.reduxAnnotationVO.highlightColorCode === "underLine") {
              element.style.textDecoration = "underline";
              element.style.backgroundColor = "white";
            } else {
              element.style.backgroundColor =
                selector.reduxAnnotationVO.highlightColorCode;
              element.style.textDecoration = "none";
            }
          }
        });
      } else {
        getChapterLayout();
      }
    } else if (
      selector.reduxAnnotationVO &&
      selector.reduxAnnotationVO.annotationStatus &&
      (selector.reduxAnnotationVO.annotationStatus === "deleted" ||
        selector.reduxAnnotationVO.annotationStatus === "deletedNote")
    ) {
      auxSectionVOList = JSON.parse(JSON.stringify(auxSectionVOList));
      let newSectionVOList = [];
      sectionVO = auxSectionVOList.filter(
        (x) => x.sectionId === selector.reduxAnnotationVO.sectionId,
      )[0];
      if (sectionVO) {
        if (sectionVO.annotationVOList) {
          sectionVO.annotationVOList = Array.isArray(sectionVO.annotationVOList)
            ? sectionVO.annotationVOList
            : [sectionVO.annotationVOList];
          if (selector.reduxAnnotationVO.annotationStatus === "deletedNote") {
            sectionVO.annotationVOList = sectionVO.annotationVOList.map(
              (element) =>
                element.annotationId === selector.reduxAnnotationVO.annotationId
                  ? { ...element, noteText: undefined }
                  : { ...element },
            );
          } else {
            sectionVO.annotationVOList = sectionVO.annotationVOList.filter(
              (element) =>
                element.annotationId !==
                selector.reduxAnnotationVO.annotationId,
            );
          }
          newSectionVOList = auxSectionVOList.map((x) =>
            x.sectionId === selector.reduxAnnotationVO.sectionId
              ? { ...sectionVO }
              : { ...x },
          );
          noteEdit.current = false;
          setLoading(false);
          setSectionVOList(auxSectionVOList);
        }
        if (selector.reduxAnnotationVO.annotationStatus === "deletedNote") {
          const element = document.getElementById(
            "briefAnchorElement" + selector.reduxAnnotationVO.annotationId,
          );
          if (element !== undefined && element !== null) {
            ReactDOM.unmountComponentAtNode(element);
          }
        }
      } else {
        getChapterLayout();
      }
    }
  };
  const handleMouseHover = (outid, type) => {
    if (type === "link") {
      let selectedlink = document.getElementById(outid).getAttribute("Cclink");
      let linkShareFlag1 = document
        .getElementById(outid)
        .getAttribute("linkShareFlag");
      outLineProfUrl.current = selectedlink;
      setIsSharedLink(linkShareFlag1 === "true" ? true : false);
      outlineId.current = outid;
      localStorage.setItem("outid", outid.split("_").pop());
    } else {
      let selectedColor = document.getElementById(outid).getAttribute("ccode");
      let isNoteThere = document.getElementById(outid).getAttribute("noteFlag");
      setNoteStatus(isNoteThere === "true" ? true : false);
      const outlineTxt = document
        .getElementById(outid)
        .querySelector(".outline_noteText");
      outLineNoteValue.current = outlineTxt ? outlineTxt.innerText : "";
      setColorsState({ ...colorsState, highlightQuickUnderLine: false });
      outlineId.current = outid;
      localStorage.setItem("outid", outid.split("_").pop());
      let selectedColorId = "";
      let selColor = null;
      if (
        selectedColor !== undefined &&
        selectedColor !== null &&
        selectedColor !== ""
      ) {
        if (selectedColor === "underLine") {
          setColorsState({ ...colorsState, highlightQuickUnderLine: true });
        }
        setTimeout(() => {
          selColor = document.querySelector(
            `button[colorcodeOutline='${selectedColor.toUpperCase && selectedColor.toUpperCase()}']`,
          );
          if (selColor !== null) {
            selectedColorId = selColor.id;
            if (selectedColorId === "underLineOut") {
              setColorsState({ ...colorsState, highlightQuickUnderLine: true });
            } else {
              ReactDOM.render(
                <GrFormClose className="selected-icon" />,
                document.getElementById(selectedColorId),
              );
              if (selectedColorId === "color-yellowOut") {
                setColorsState({
                  ...colorsState,
                  colorYellow: true,
                  highlightQuickUnderLine: false,
                });
              } else if (selectedColorId === "color-greenOut") {
                setColorsState({
                  ...colorsState,
                  colorGreen: true,
                  highlightQuickUnderLine: false,
                });
              } else if (selectedColorId === "color-blueOut") {
                setColorsState({
                  ...colorsState,
                  colorBlue: true,
                  highlightQuickUnderLine: false,
                });
              } else if (selectedColorId === "color-pinkOut") {
                setColorsState({
                  ...colorsState,
                  colorPink: true,
                  highlightQuickUnderLine: false,
                });
              } else if (selectedColorId === "color-orangeOut") {
                setColorsState({
                  ...colorsState,
                  colorOrange: true,
                  highlightQuickUnderLine: false,
                });
              } else if (selectedColorId === "color-purpleOut") {
                setColorsState({
                  ...colorsState,
                  colorPurple: true,
                  highlightQuickUnderLine: false,
                });
              } else if (selectedColorId === "color-cyanOut") {
                setColorsState({
                  ...colorsState,
                  colorCyan: true,
                  highlightQuickUnderLine: false,
                });
              } else if (selectedColorId === "color-lightNavyOut") {
                setColorsState({
                  ...colorsState,
                  colorLightNavy: true,
                  highlightQuickUnderLine: false,
                });
              } else if (selectedColorId === "color-lightCoralOut") {
                setColorsState({
                  ...colorsState,
                  colorLightCoral: true,
                  highlightQuickUnderLine: false,
                });
              } else if (selectedColorId === "color-sandriftOut") {
                setColorsState({
                  ...colorsState,
                  colorSandrift: true,
                  highlightQuickUnderLine: false,
                });
              } else if (selectedColorId === "color-gainsboroOut") {
                setColorsState({
                  ...colorsState,
                  colorGainsboro: true,
                  highlightQuickUnderLine: false,
                });
              }
            }
          }
        }, 500);
      }
    }
  };

  const chapterCache = useRef({});
  const chapterLayoutRequestId = useRef(0);
  const chapterLayoutAbortController = useRef(null);
  const latestChapterIdRef = useRef(currentState.currentChapterId);

  useEffect(() => {
    latestChapterIdRef.current = currentState.currentChapterId;
  }, [currentState.currentChapterId]);

  useEffect(() => {
    return () => {
      if (chapterLayoutAbortController.current) {
        chapterLayoutAbortController.current.abort();
      }
    };
  }, []);

  const getChapterLayout = async (
    chapterIdToFetch = currentState.currentChapterId,
  ) => {
    if (!chapterIdToFetch) return;

    chapterLayoutRequestId.current += 1;
    const requestId = chapterLayoutRequestId.current;
    latestChapterIdRef.current = chapterIdToFetch;

    if (chapterLayoutAbortController.current) {
      chapterLayoutAbortController.current.abort();
    }

    const controller = new AbortController();
    chapterLayoutAbortController.current = controller;

    const isLatestChapterRequest = () =>
      chapterLayoutRequestId.current === requestId &&
      latestChapterIdRef.current === chapterIdToFetch &&
      !controller.signal.aborted;

    if (chapterCache.current[chapterIdToFetch]) {
      setSectionVOList(chapterCache.current[chapterIdToFetch]);
    } else {
      // Clear immediately so the outline from the previous chapter is not
      // visible while the newly selected chapter is loading.
      setSectionVOList([]);
    }

    setLoading(true);

    try {
      let pageNum = 0;
      let totalPages = 1;
      let allAnnotations = [];
      let latestSectionVOList = [];

      while (pageNum < totalPages) {
        const reqData = {
          userVO: {
            userId: userVO.userId,
            userRole: userVO.userRole,
            userRoleId: userVO.userRoleId,
            userActivityVO: {
              lastReadChapterId: "",
              lastViewedOutlineId: "",
              pageNavigatingTo: "Outline",
              lastActivityCode: "BOOKSHELF",
              lastReadBookId: bookVO.bookId,
              lastReadParagraphId: "para01",
              lastReadSubSectionId: "subsec01",
              pageNavigatingFrom: "ClassInsight",
              lastViewedOutlineType: "chapterOutline",
            },
            sessionVO: {
              appType: "web",
              deviceMacId: "",
              keepMeLoggedInFlag: keepMeLogIn,
              deviceOS: localStorage.getItem("deviceOS"),
              deviceType: localStorage.getItem("deviceType"),
              browserName: localStorage.getItem("browserName"),
              sessionAuthenticationToken: userVO.sessionAuthenticationToken,
            },
          },
          annotationVO: {
            pageNum,
            bookId: bookVO.bookId,
            ereaderNotesAndHighlightsPopoverFlowFlag: "true",
            chapterId: chapterIdToFetch,
          },
        };

        const requestOptions1 = {
          method: "POST",
          body: JSON.stringify(reqData),
          signal: controller.signal,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        };

        const response = await fetch(
          `${localStorage.getItem("ENV")}/manageOutlineService/getChapterOutlineRV`,
          requestOptions1,
        );
        const data = await response.json();

        // Do not let an old chapter request update the current outline.
        if (!isLatestChapterRequest()) return;

        if (data.status !== "true") {
          handleException(data);
          return;
        }

        totalPages = Number(data.totalPages || 1);

        if (data.annotationVOList) {
          const annotationVOListData = Array.isArray(data.annotationVOList)
            ? data.annotationVOList
            : [data.annotationVOList];
          allAnnotations = [...allAnnotations, ...annotationVOListData];
        }

        if (data.sectionVOList) {
          latestSectionVOList = Array.isArray(data.sectionVOList)
            ? data.sectionVOList
            : [data.sectionVOList];
        }

        pageNum += 1;
      }

      if (!isLatestChapterRequest()) return;

      const outlineGroupBy = allAnnotations.reduce((acc, item) => {
        const key = item?.sectionId == null ? "-9999" : String(item.sectionId);
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      const sectVoListData = latestSectionVOList.map((item) => {
        const sectionKey = String(item.sectionId);
        const annotationVOList = outlineGroupBy[sectionKey]
          ? [
              ...new Map(
                outlineGroupBy[sectionKey].map((annotation) => [
                  annotation.annotationId,
                  annotation,
                ]),
              ).values(),
            ].sort(
              (a, b) =>
                parseInt(a.highlightStartOffset) -
                parseInt(b.highlightStartOffset),
            )
          : [];

        return {
          ...item,
          annotationVOList,
        };
      });

      if (!isLatestChapterRequest()) return;

      chapterCache.current[chapterIdToFetch] = sectVoListData;
      setSectionVOList(sectVoListData);
      setState((prevState) => ({ ...prevState, chapterId: chapterIdToFetch }));
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      }
    } finally {
      if (isLatestChapterRequest()) {
        setLoading(false);
      }
    }
  };

  const colorBtnPressed = (e, newColor) => {
    let removeCloseIcon = document.querySelectorAll(
      ".color-pallete .colorButton",
    );
    for (let i = 0; i < removeCloseIcon.length; i++) {
      ReactDOM.unmountComponentAtNode(
        document.getElementById(removeCloseIcon[i].id),
      );
    }
    setColorsState({
      ...colorsState,
      colorYellow: false,
      colorGreen: false,
      colorBlue: false,
      colorPink: false,
      colorOrange: false,
      colorPurple: false,
      colorCyan: false,
      colorLightNavy: false,
      colorLightCoral: false,
      colorSandrift: false,
      colorGainsboro: false,
      highlightQuickUnderLine: false,
    });
    let colorCodeId = e.currentTarget.id;
    let addCloseIcon = document.getElementById(colorCodeId);
    colorCodeId === "underLine"
      ? setColorsState({ ...colorsState, highlightQuickUnderLine: true })
      : ReactDOM.render(
          <GrFormClose className="selected-icon" />,
          addCloseIcon,
        );
    saveHighlightsFromOutline(newColor);
  };
  const colorBtnPressedBrief = (e, newColor) => {
    let removeCloseIcon = document.querySelectorAll(
      ".color-pallete .colorButton",
    );
    for (let i = 0; i < removeCloseIcon.length; i++) {
      ReactDOM.unmountComponentAtNode(
        document.getElementById(removeCloseIcon[i].id),
      );
    }
    setColorsState({
      ...colorsState,
      colorYellow: false,
      colorGreen: false,
      colorBlue: false,
      colorPink: false,
      colorOrange: false,
      colorPurple: false,
      colorCyan: false,
      colorLightNavy: false,
      colorLightCoral: false,
      colorSandrift: false,
      colorGainsboro: false,
      highlightQuickUnderLine: false,
    });
    let colorCodeId = e.currentTarget.id;
    let addCloseIcon = document.getElementById(colorCodeId);
    colorCodeId === "underLine"
      ? setColorsState({ ...colorsState, highlightQuickUnderLine: true })
      : ReactDOM.render(
          <GrFormClose className="selected-icon" />,
          addCloseIcon,
        );
    saveBriefFromOutline(newColor, "");
  };
  const saveBriefFromOutline = (color, outlineId) => {
    const ebookElement = document.getElementById(localStorage.getItem("outid"));
    setBriefNoteLoading(true);
    let sectID = "";
    let AnnotationID1 = document.getElementById(
      "outline_" + localStorage.getItem("outid"),
    );
    if (AnnotationID1) {
      if (AnnotationID1.parentElement.getAttribute("sectionid") !== null) {
        sectID = AnnotationID1.parentElement.getAttribute("sectionid");
      } else if (
        AnnotationID1.parentElement.parentElement.getAttribute("sectionid") !==
        null
      ) {
        sectID =
          AnnotationID1.parentElement.parentElement.getAttribute("sectionid");
      }
    }
    if (outlineId !== "") {
      let i = document.getElementById(outlineId);
      i.removeChild(i.childNodes[i.childNodes.length - 1]);
    }
    let updatedNoteText = outLineNoteValue.current,
      upnote = "";
    if (updatedNoteText.trim() === "" && noteEdit.current === false) {
      upnote = document.querySelector(
        "#" + "outline_" + localStorage.getItem("outid") + " .outline_noteText",
      );
      updatedNoteText = upnote !== null ? upnote.textContent : "";
    }
    let updatedNoteTextLen = updatedNoteText.trim().length;
    const { userId, userRole, userRoleId, sessionAuthenticationToken } = userVO;
    const { chapterId, bookId, lastReadPageNum, chapterTitle } = bookVO;
    let reqData = {
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadSectionId: "",
          lastReadBookId: bookId,
          lastViewedOutlineId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastReadParagraphId: "para01",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadPageNum: lastReadPageNum,
          lastReadSubSectionId: "subsec01",
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      briefVO: {
        sectionId: sectID,
        sectionTitle: null,
        chapterId: chapterId,
        bookId: bookVO.bookId,
        highlightColorCode: color,
        chapterTitle: bookVO.chapterTitle,
        noteText: outLineNoteValue.current.trim(),
        annotationId: localStorage.getItem("outid"),
        pageNumber: document.getElementById("pageNumTxt").value,
        highlightEndParaId: ebookElement.getAttribute("briefendparaid"),
        highlightStartParaId: ebookElement.getAttribute("briefstartparaid"),
        enclosingParaList: ebookElement
          .getAttribute("enclosingparaidstring")
          .split("|"),
        highlightParaEndOffset: parseInt(
          ebookElement.getAttribute("briefparaendoffset"),
        ),
        highlightParaStartOffset: parseInt(
          ebookElement.getAttribute("briefparastartoffset"),
        ),
        highlightText: document
          .getElementById("outline_" + localStorage.getItem("outid"))
          .querySelector("span").innerText,
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageCases/updateChapterBrief`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (typeof data.sessionAuthenticationToken != "undefined") {
            localStorage.setItem(
              "sessionAuthenticationToken",
              data.sessionAuthenticationToken,
            );
          }
          reqData.briefVO.annotationStatus = "updated";
          reqData.briefVO.dppContentType = "brief";
          if (noteEdit.current !== false) {
            if (updatedNoteTextLen > 0) {
              if (
                outLineNoteValue.current.trim() === "" &&
                noteEdit.current === true
              ) {
                reqData.briefVO.annotationStatus = "deletedNote";
                reqData.briefVO.noteText = undefined;
              } else {
                reqData.briefVO.noteText = updatedNoteText;
              }
              reqData.briefVO.annotationStatus = "updatedNote";
              if (
                document
                  .querySelector(
                    "#" + "outline_" + localStorage.getItem("outid"),
                  )
                  .querySelector(".outline_noteText") !== null
              ) {
                document
                  .querySelector(
                    "#" + "outline_" + localStorage.getItem("outid"),
                  )
                  .querySelector(".outline_noteText").style.display = "block";
              }
            } else {
              reqData.briefVO.annotationStatus = "deletedNote";
              reqData.briefVO.noteText = undefined;
            }
          }
          onHandlesetReduxAnnotationVO(reqData.briefVO);
          let relatedHighLightTagsToRepaint1 = document.querySelectorAll(
            `briefstag[id^="${localStorage.getItem("outid")}"]`,
          );
          if (
            relatedHighLightTagsToRepaint1 !== null &&
            relatedHighLightTagsToRepaint1 !== undefined
          ) {
            for (let j = 0; j < relatedHighLightTagsToRepaint1.length; j++) {
              if (color === "underLine") {
                relatedHighLightTagsToRepaint1[j].setAttribute(
                  "style",
                  "text-decoration: underline !important;",
                );
                relatedHighLightTagsToRepaint1[j].setAttribute(
                  "colorCodeId",
                  "underline",
                );
              } else {
                relatedHighLightTagsToRepaint1[j].setAttribute(
                  "style",
                  "background-color:" + color + " !important;",
                );
                relatedHighLightTagsToRepaint1[j].setAttribute(
                  "colorCodeId",
                  color,
                );
              }
              relatedHighLightTagsToRepaint1[j].setAttribute(
                "briefnote",
                updatedNoteText,
              );
              relatedHighLightTagsToRepaint1[j].setAttribute(
                "colorcodeId",
                color,
              );
            }
          }
          let selectedHighlightColor = color;
          let actualSelectedNoteId = localStorage.getItem("outid");
          let yValue = document
            .getElementById(actualSelectedNoteId)
            .getBoundingClientRect().top;
          if (!selectedHighlightColor) {
            selectedHighlightColor =
              document.getElementById(actualSelectedNoteId).style
                .backgroundColor;
          }
          let updatedNoteText1 = updatedNoteText.trim().length;
          if (noteEdit.current === true && updatedNoteText1 === 0) {
            let spnNotesCollection = document.querySelectorAll(
              `span[id="${actualSelectedNoteId}"]`,
            );
            let briefTextClassElements =
              document.getElementsByClassName("labelNoteWrapper");
            let briefTextElementsCount = briefTextClassElements.length;
            if (briefTextElementsCount > 0 && spnNotesCollection.length > 0) {
              for (let i = 0; i < briefTextClassElements.length; i++) {
                if (
                  briefTextClassElements[i].id.substring(
                    12,
                    briefTextClassElements[i].id.length,
                  ) ===
                  spnNotesCollection[0].id.substring(
                    7,
                    spnNotesCollection[0].id.length,
                  )
                ) {
                  updatingBrief = true;
                  briefTextClassElements[i].parentNode.remove();
                  break;
                }
              }
            }
            if (typeof spnNotesCollection !== "undefined") {
              if (typeof spnNotesCollection[0] !== "undefined") {
                let briefSpanBlockClassElements =
                  document.querySelectorAll(".briefSpanBlock");
                for (let i = 0; i < briefSpanBlockClassElements.length; i++) {
                  if (
                    briefSpanBlockClassElements[i].id.substring(
                      7,
                      briefSpanBlockClassElements[0].id.length,
                    ) ===
                    spnNotesCollection[0].id.substring(
                      7,
                      spnNotesCollection[0].id.length,
                    )
                  ) {
                    briefSpanBlockClassElements[i].parentNode.remove();
                    break;
                  }
                }
              }
            }
          }
          if (noteEdit.current === true && updatedNoteText1 > 0) {
            displayBriefOnRight(
              actualSelectedNoteId,
              selectedHighlightColor,
              yValue,
              "",
              updatedNoteText1,
            );
          }
        } else if (data.wkErrorCode) {
          handleException(data);
        }
        if (document.getElementById("popover-basic"))
          document.getElementById("popover-basic").style.display = "none";
        setBriefNoteLoading(false);
        document.getElementById("outlineIcon").focus();
      })
      .catch((error) => {
        if (document.getElementById("popover-basic"))
          document.getElementById("popover-basic").style.display = "none";
        setBriefNoteLoading(false);
        document.getElementById("outlineIcon").focus();
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const removeHighLightColor = async (e) => {
    let colorBtId = e.currentTarget.id;
    if (colorBtId === "underLineOut") {
      setColorsState({ ...colorsState, highlightQuickUnderLine: false });
    } else {
      ReactDOM.unmountComponentAtNode(document.getElementById(colorBtId));
      if (colorBtId === "color-yellowOut") {
        setColorsState({ ...colorsState, colorYellow: false });
      } else if (colorBtId === "color-greenOut") {
        setColorsState({ ...colorsState, colorGreen: false });
      } else if (colorBtId === "color-blueOut") {
        setColorsState({ ...colorsState, colorBlue: false });
      } else if (colorBtId === "color-pinkOut") {
        setColorsState({ ...colorsState, colorPink: false });
      } else if (colorBtId === "color-orangeOut") {
        setColorsState({ ...colorsState, colorOrange: false });
      } else if (colorBtId === "color-purpleOut") {
        setColorsState({ ...colorsState, colorPurple: false });
      } else if (colorBtId === "color-cyanOut") {
        setColorsState({ ...colorsState, colorCyan: false });
      } else if (colorBtId === "color-lightNavyOut") {
        setColorsState({ ...colorsState, colorLightNavy: false });
      } else if (colorBtId === "color-lightCoralOut") {
        setColorsState({ ...colorsState, colorLightCoral: false });
      } else if (colorBtId === "color-sandriftOut") {
        setColorsState({ ...colorsState, colorSandrift: false });
      } else if (colorBtId === "color-gainsboroOut") {
        setColorsState({ ...colorsState, colorGainsboro: false });
      }
    }
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadSectionId: "",
          lastViewedOutlineId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadBookId: bookVO.bookId,
          lastReadParagraphId: "para01",
          lastReadSubSectionId: "subsec01",
          lastReadPageNum: bookVO.lastReadPageNum,
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      annotationVO: {
        chapterId: chapterId,
        bookId: bookVO.bookId,
        annotationType: "annotation",
        annotationId: localStorage.getItem("outid"),
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    setLoading(true);
    const data = await (
      await fetch(
        `${localStorage.getItem("ENV")}/manageAnnotationService/deleteChapterHighlights`,
        requestOptions1,
      )
    ).json();
    if (data.status === "true") {
      reqData.annotationVO.annotationStatus = "deleted";
      reqData.annotationVO.sectionId = annotationSectionId;
      onHandlesetReduxAnnotationVO(reqData.annotationVO);
      if (typeof data.sessionAuthenticationToken != "undefined") {
        localStorage.setItem(
          "sessionAuthenticationToken",
          data.sessionAuthenticationToken,
        );
      }
      let outlineIdRemove = "outline_" + localStorage.getItem("outid");
      if (document.getElementById("popover-basic"))
        document.getElementById("popover-basic").style.display = "none";
      if (localStorage.getItem("outid") !== null) {
        let relatedHighLightTags = document.querySelectorAll(
          `briefstag[id^="${localStorage.getItem("outid")}"]`,
        );
        for (let i = 0; i < relatedHighLightTags.length; i++) {
          let highlightSpanTag = document.getElementById(
            relatedHighLightTags[i].id,
          );
          let parent = highlightSpanTag.parentNode;
          while (highlightSpanTag.firstChild)
            parent.insertBefore(highlightSpanTag.firstChild, highlightSpanTag);
          parent.removeChild(highlightSpanTag);
        }
        let spnNotesCollection = document.querySelectorAll(
          `span[id="colSpan${localStorage.getItem("outid")}"]`,
        );
        let briefTextClassElements =
          document.querySelectorAll(".labelNoteWrapper");
        let briefTextElementsCount = briefTextClassElements.length;
        if (briefTextElementsCount > 0 && spnNotesCollection.length > 0) {
          for (let i = 0; i < briefTextClassElements.length; i++) {
            if (
              briefTextClassElements[i].id.substring(
                12,
                briefTextClassElements[i].id.length,
              ) ===
              spnNotesCollection[0].id.substring(
                7,
                spnNotesCollection[0].id.length,
              )
            ) {
              briefTextClassElements[i].parentNode.remove();
              break;
            }
          }
        }
      }
      if (localStorage.getItem("outid") !== null) {
        let relatedHighLightTags = document.querySelectorAll(
          `highlight[id^="${localStorage.getItem("outid")}"]`,
        );
        for (let i = 0; i < relatedHighLightTags.length; i++) {
          let highlightSpanTag = document.getElementById(
            relatedHighLightTags[i].id,
          );
          let parent = highlightSpanTag.parentNode;
          while (highlightSpanTag.firstChild)
            parent.insertBefore(highlightSpanTag.firstChild, highlightSpanTag);
          parent.removeChild(highlightSpanTag);
        }
        let notesTextClassElements = document.querySelectorAll(".notesText");
        for (let i = 0; i < notesTextClassElements.length; i++) {
          if (
            notesTextClassElements[i].id.substring(
              8,
              notesTextClassElements[i].id.length,
            ) === localStorage.getItem("outid")
          ) {
            notesTextClassElements[i].parentNode.remove();
            break;
          }
        }
        let notesSpanBlockClassElements =
          document.querySelectorAll(".notesSpanBlock");
        for (let i = 0; i < notesSpanBlockClassElements.length; i++) {
          if (
            notesSpanBlockClassElements[i].id === localStorage.getItem("outid")
          ) {
            notesSpanBlockClassElements[i].parentNode.removeChild(
              notesSpanBlockClassElements[i],
            );
            break;
          }
        }
      }
    } else if (data.wkErrorCode) {
      handleException(data);
    }
    setLoading(false);
  };
  const saveHighlightsFromOutline = (color) => {
    setLoading(true);
    let sectID = "";
    const { bookVO, userVO, chapterId } = props;
    let AnnotationID = document.getElementById(
      "outline_" + localStorage.getItem("outid"),
    );
    if (AnnotationID) {
      if (AnnotationID.parentElement.getAttribute("sectionid") !== null) {
        sectID = AnnotationID.parentElement.getAttribute("sectionid");
      } else if (
        AnnotationID.parentElement.parentElement.getAttribute("sectionid") !==
        null
      ) {
        sectID =
          AnnotationID.parentElement.parentElement.getAttribute("sectionid");
      }
    }
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadPageNum: "",
          lastReadSectionId: "",
          lastViewedOutlineId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadBookId: bookVO.bookId,
          lastReadParagraphId: "para01",
          lastReadSubSectionId: "subsec01",
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      annotationVO: {
        sectionId: sectID,
        chapterId: chapterId,
        bookId: bookVO.bookId,
        highlightColorCode: color,
        annotationId: localStorage.getItem("outid"),
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageAnnotationService/updateChapterHighlights`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (typeof data.sessionAuthenticationToken != "undefined") {
            localStorage.setItem(
              "sessionAuthenticationToken",
              data.sessionAuthenticationToken,
            );
          }
          let upnote = document.getElementById(
            "outline_" + localStorage.getItem("outid"),
          );
          let updatedNoteText = upnote !== null ? upnote.textContent : "";
          let updatedNoteTextLen = updatedNoteText.trim().length;
          reqData.annotationVO.annotationStatus = "updated";
          reqData.annotationVO.dppContentType = "annotation";
          if (updatedNoteTextLen > 0)
            reqData.annotationVO.noteText = updatedNoteText;
          onHandlesetReduxAnnotationVO(reqData.annotationVO);
          if (color === "underLine") {
            upnote.setAttribute(
              "style",
              "text-decoration: underline !important;",
            );
            upnote.setAttribute("ccode", "underline");
          } else {
            upnote.setAttribute(
              "style",
              "background-color:" + color + " !important;",
            );
            upnote.setAttribute("ccode", color);
          }
          let relatedHighLightTagsToRepaint1 = document.querySelectorAll(
            `highlight[id^="${localStorage.getItem("outid")}"]`,
          );
          if (
            relatedHighLightTagsToRepaint1 !== null &&
            relatedHighLightTagsToRepaint1 !== undefined
          ) {
            for (let j = 0; j < relatedHighLightTagsToRepaint1.length; j++) {
              if (color === "underLine") {
                relatedHighLightTagsToRepaint1[j].setAttribute(
                  "style",
                  "text-decoration: underline !important;",
                );
                relatedHighLightTagsToRepaint1[j].setAttribute(
                  "colorCodeId",
                  "underline",
                );
              } else {
                relatedHighLightTagsToRepaint1[j].setAttribute(
                  "style",
                  "background-color:" + color + " !important;",
                );
                relatedHighLightTagsToRepaint1[j].setAttribute(
                  "colorCodeId",
                  color,
                );
              }
            }
          }
        } else if (data.wkErrorCode) {
          handleException(data);
        }
        if (document.getElementById("popover-basic"))
          document.getElementById("popover-basic").style.display = "none";
        setLoading(false);
        document.getElementById("outlineIcon").focus();
      })
      .catch((error) => {
        if (document.getElementById("popover-basic"))
          document.getElementById("popover-basic").style.display = "none";
        setLoading(false);
        document.getElementById("outlineIcon").focus();
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const handleChangeNote = (e) => {
    outLineNoteValue.current = e.target.value;
    noteEdit.current = true;
    outLineProfUrl.current = e.target.value;
  };
  const handleBlurNoteAdd = async (e, outlineId) => {
    setLoading(true);
    let i = document.getElementById(outlineId);
    let noteVal = outLineNoteValue.current;
    i.removeChild(i.childNodes[i.childNodes.length - 1]);
    let AnnotationID2 = document.getElementById(
      "outline_" + localStorage.getItem("outid"),
    );
    let sectID1 = AnnotationID2
      ? AnnotationID2.parentElement.getAttribute("sectionid")
      : "";
    if (noteVal.trim() !== "") {
      let reqData = {
        userVO: {
          userId: userVO.userId,
          userRole: userVO.userRole,
          userRoleId: userVO.userRoleId,
          userActivityVO: {
            lastReadPageNum: "",
            lastReadSectionId: "",
            lastViewedOutlineId: "",
            pageNavigatingTo: "EReader",
            lastActivityCode: "BOOKSHELF",
            pageNavigatingFrom: "EReader",
            lastReadBookId: bookVO.bookId,
            lastReadParagraphId: "para01",
            lastReadSubSectionId: "subsec01",
            lastReadChapterId: bookVO.chapterId,
          },
          sessionVO: {
            appType: "web",
            deviceMacId: "",
            keepMeLoggedInFlag: keepMeLogIn,
            deviceOS: localStorage.getItem("deviceOS"),
            deviceType: localStorage.getItem("deviceType"),
            browserName: localStorage.getItem("browserName"),
            sessionAuthenticationToken: userVO.sessionAuthenticationToken,
          },
        },
        annotationVO: {
          noteText: noteVal,
          sectionId: sectID1,
          bookId: bookVO.bookId,
          chapterId: bookVO.chapterId,
          chapterTitle: bookVO.chapterTitle,
          annotationId: localStorage.getItem("outid"),
        },
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      const data = await (
        await fetch(
          `${localStorage.getItem("ENV")}/manageAnnotationService/addChapterNote`,
          requestOptions1,
        )
      ).json();
      if (data.status === "true") {
        if (typeof data.sessionAuthenticationToken != "undefined") {
          localStorage.setItem(
            "sessionAuthenticationToken",
            data.sessionAuthenticationToken,
          );
        }
        reqData.annotationVO.annotationStatus = "updatedNote";
        reqData.annotationVO.dppContentType = "annotation";
        if (noteVal) reqData.annotationVO.noteText = noteVal;
        onHandlesetReduxAnnotationVO(reqData.annotationVO);
        if (document.getElementById(localStorage.getItem("outid")) !== null) {
          document
            .getElementById(localStorage.getItem("outid"))
            .setAttribute("noteText", noteVal);
          let yValue = document
            .getElementById(localStorage.getItem("outid"))
            .getBoundingClientRect().top;
          displayNotesOnRight(
            noteVal,
            localStorage.getItem("outid"),
            yValue,
            false,
          );
        }
      } else if (data.wkErrorCode) {
        handleException(data);
      }
      setLoading(false);
      if (document.getElementById("outlineIcon"))
        document.getElementById("outlineIcon").focus();
    } else {
      setLoading(false);
    }
  };
  const handleBlurNoteUpdate = (e, outlineId) => {
    let noteVal1 = outLineNoteValue.current;
    let sectID3 = "";
    let AnnotationID3 = document.getElementById(
      "outline_" + localStorage.getItem("outid"),
    );
    if (AnnotationID3) {
      if (AnnotationID3.parentElement.getAttribute("sectionid") !== null) {
        sectID3 = AnnotationID3.parentElement.getAttribute("sectionid");
      } else if (
        AnnotationID3.parentElement.parentElement.getAttribute("sectionid") !==
        null
      ) {
        sectID3 =
          AnnotationID3.parentElement.parentElement.getAttribute("sectionid");
      }
    }
    if (noteFlagDelete === true && noteVal1.trim() === "") {
      let i = document.getElementById(outlineId);
      let noteValUpdate = outLineNoteValue.current;
      i.removeChild(i.childNodes[i.childNodes.length - 1]);
      deleteNoteFromOutline();
    } else {
      let i = document.getElementById(outlineId);
      let noteValUpdate = outLineNoteValue.current;
      i.removeChild(i.childNodes[i.childNodes.length - 1]);
      const { bookVO, userVO, chapterId } = props;
      let reqData = {
        userVO: {
          userId: userVO.userId,
          userRole: userVO.userRole,
          userRoleId: userVO.userRoleId,
          userActivityVO: {
            lastReadSectionId: "",
            lastViewedOutlineId: "",
            pageNavigatingTo: "EReader",
            lastReadChapterId: chapterId,
            lastReadBookId: bookVO.bookId,
            lastReadParagraphId: "para01",
            lastActivityCode: "BOOKSHELF",
            pageNavigatingFrom: "EReader",
            lastReadSubSectionId: "subsec01",
            lastReadPageNum: bookVO.lastReadPageNum,
          },
          sessionVO: {
            appType: "web",
            deviceMacId: "",
            keepMeLoggedInFlag: keepMeLogIn,
            deviceOS: localStorage.getItem("deviceOS"),
            deviceType: localStorage.getItem("deviceType"),
            browserName: localStorage.getItem("browserName"),
            sessionAuthenticationToken: userVO.sessionAuthenticationToken,
          },
        },
        annotationVO: {
          sectionId: sectID3,
          bookId: bookVO.bookId,
          noteText: noteValUpdate,
          chapterId: bookVO.chapterId,
          chapterTitle: bookVO.chapterTitle,
          annotationId: localStorage.getItem("outid"),
        },
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      fetch(
        `${localStorage.getItem("ENV")}/manageAnnotationService/updateChapterNote`,
        requestOptions1,
      )
        .then((response) => response.json())
        .then(function (data) {
          if (data.status === "true") {
            if (typeof data.sessionAuthenticationToken != "undefined") {
              localStorage.setItem(
                "sessionAuthenticationToken",
                data.sessionAuthenticationToken,
              );
            }
            reqData.annotationVO.annotationStatus = "updatedNote";
            reqData.annotationVO.dppContentType = "annotation";
            if (noteValUpdate) reqData.annotationVO.noteText = noteValUpdate;
            onHandlesetReduxAnnotationVO(reqData.annotationVO);
            document
              .querySelector("#" + outlineId)
              .querySelector(".outline_noteText").style.display = "block";
            if (
              document.getElementById(localStorage.getItem("outid")) !== null
            ) {
              document
                .getElementById(localStorage.getItem("outid"))
                .setAttribute("noteText", noteValUpdate);
            }
          } else if (data.wkErrorCode) {
            handleException(data);
          }
          if (document.getElementById("popover-basic"))
            document.getElementById("popover-basic").style.display = "none";
          if (document.getElementById("outlineIcon"))
            document.getElementById("outlineIcon").focus();
          setLoading(false);
        })
        .catch((error) => {
          if (document.getElementById("popover-basic"))
            document.getElementById("popover-basic").style.display = "none";
          setLoading(false);
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
  };
  const AnnotateFromOutline = async (e, outlineId, noteStatus, type) => {
    noteFlagDelete = false;
    const annotate = document.querySelector("#" + outlineId);
    let currentColor = annotate.getAttribute("ccode");
    if (noteStatus === false) {
      var element = document.createElement("textarea");
      element.setAttribute("type", "text");
      element.setAttribute("name", "outLineNoteValue");
      element.setAttribute("aria-label", `Add ${type}`);
      element.className = "textAreaNote";
      element.id = "annotation";
      element.onchange = handleChangeNote;
      annotate.appendChild(element);
      if (annotate.querySelector(".outline_noteText")) {
        element.defaultValue =
          annotate.querySelector(".outline_noteText").innerText;
      }
      annotate.querySelector("#annotation").focus();
      if (type === "annotation")
        await document
          .getElementById("annotation")
          .addEventListener(
            "blur",
            async () => await handleBlurNoteAdd(e, outlineId),
          );
      else if (type === "brief")
        document
          .getElementById("annotation")
          .addEventListener("blur", () =>
            saveBriefFromOutline(currentColor, outlineId),
          );
    } else if (noteStatus === true) {
      let currentNote = document
        .querySelector("#" + outlineId)
        .querySelector(".outline_noteText").innerText;
      noteFlagDelete = currentNote !== "" ? true : false;
      document
        .querySelector("#" + outlineId)
        .querySelector(".outline_noteText").style.display = "none";
      var element = document.createElement("textarea");
      element.setAttribute("type", "text");
      element.setAttribute("name", "outLineNoteValue");
      element.setAttribute("aria-label", `Edit ${type}`);
      element.className = "textAreaNote";
      element.id = "annotation";
      element.value = currentNote;
      element.onchange = handleChangeNote;
      document.getElementById(outlineId).appendChild(element);
      document
        .querySelector("#" + outlineId)
        .querySelector("#annotation")
        .focus();
      if (type === "annotation")
        document
          .getElementById("annotation")
          .addEventListener("blur", () => handleBlurNoteUpdate(e, outlineId));
      else if (type === "brief")
        document
          .getElementById("annotation")
          .addEventListener("blur", () =>
            saveBriefFromOutline(currentColor, outlineId),
          );
    }
    if (document.getElementById("popover-basic"))
      document.getElementById("popover-basic").style.display = "none";
  };
  const deleteNoteFromOutline = (e) => {
    const enclosingParaList = document.querySelector(
      `[id="${localStorage.getItem("outid")}"]`,
    );
    let sectID4 = "";
    let AnnotationID4 = document.getElementById(
      "outline_" + localStorage.getItem("outid"),
    );
    if (AnnotationID4) {
      if (AnnotationID4.parentElement.getAttribute("sectionid") !== null) {
        sectID4 = AnnotationID4.parentElement.getAttribute("sectionid");
      } else if (
        AnnotationID4.parentElement.parentElement.getAttribute("sectionid") !==
        null
      ) {
        sectID4 =
          AnnotationID4.parentElement.parentElement.getAttribute("sectionid");
      }
    }
    const { userId, userRole, userRoleId, sessionAuthenticationToken } = userVO;
    const { chapterId, bookId, lastReadPageNum, chapterTitle } = bookVO;
    let reqData = {
      userVO: {
        userId: userId,
        userRole: userRole,
        userRoleId: userRoleId,
        userActivityVO: {
          lastReadSectionId: "",
          lastReadBookId: bookId,
          lastViewedOutlineId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastReadParagraphId: "para01",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadSubSectionId: "subsec01",
          lastReadPageNum: lastReadPageNum,
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      annotationVO: {
        bookId: bookId,
        sectionId: sectID4,
        sectionTitle: null,
        chapterId: chapterId,
        chapterTitle: chapterTitle,
        annotationId: localStorage.getItem("outid"),
        highlightEndParaId:
          enclosingParaList.getAttribute("highlightendparaid") || "",
        enclosingParaList:
          [enclosingParaList.getAttribute("highlightendparaid")] || [],
        highlightStartParaId:
          enclosingParaList.getAttribute("highlightendparaid") || "",
        highlightParaEndOffset:
          enclosingParaList.getAttribute("highlightparaendoffset") || null,
        highlightParaStartOffset:
          enclosingParaList.getAttribute("highlightparastartoffset") || null,
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageAnnotationService/deleteChapterNote`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then(function (data) {
        if (data.status === "true") {
          if (typeof data.sessionAuthenticationToken != "undefined") {
            localStorage.setItem(
              "sessionAuthenticationToken",
              data.sessionAuthenticationToken,
            );
          }
          reqData.annotationVO.annotationStatus = "deletedNote";
          reqData.annotationVO.noteText = undefined;
          onHandlesetReduxAnnotationVO(reqData.annotationVO);
          if (document.getElementById(localStorage.getItem("outid")) !== null) {
            document
              .getElementById(localStorage.getItem("outid"))
              .setAttribute("noteText", " ");
            let notesTextClassElements =
              document.getElementsByClassName("notesText");
            for (let i = 0; i < notesTextClassElements.length; i++) {
              if (
                notesTextClassElements[i].id.substring(
                  8,
                  notesTextClassElements[i].id.length,
                ) === localStorage.getItem("outid")
              ) {
                notesTextClassElements[i].parentNode.remove();
                break;
              }
            }
          }
        } else if (data.wkErrorCode) {
          handleException(data);
        }
        if (document.getElementById("popover-basic"))
          document.getElementById("popover-basic").style.display = "none";
        setLoading(false);
      })
      .catch((error) => {
        if (document.getElementById("popover-basic"))
          document.getElementById("popover-basic").style.display = "none";
        setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const displayNotesOnRight = (noteText, noteId, topValue, isLink) => {
    let allNotes = "";
    if (document.querySelector("#anchorElement" + noteId)) {
      document.querySelector("#anchorElement" + noteId).remove();
    }
    let containerTop = document
      .getElementById("notes-container")
      .getBoundingClientRect().top;
    let clickableAnchorElement = document.createElement("A");
    clickableAnchorElement.id = "anchorElement" + noteId;
    clickableAnchorElement.setAttribute("noteText", noteText);
    clickableAnchorElement.setAttribute("aria-label", noteText);
    clickableAnchorElement.style.color = "#333333";
    let notesText = document.createElement("div");
    notesText.id = "notesDiv" + noteId;
    let timeCount = 1;
    let countOfAnnotationsInChapter = 300;
    if (localStorage.getItem("annotationListForChapter") !== null) {
      countOfAnnotationsInChapter = localStorage
        .getItem("annotationListForChapter")
        .split(",").length;
    } else {
      countOfAnnotationsInChapter = 1000;
    }
    if (countOfAnnotationsInChapter < 50) {
      timeCount = 1;
    } else if (
      countOfAnnotationsInChapter > 50 &&
      countOfAnnotationsInChapter < 150
    ) {
      timeCount = 800;
    } else {
      timeCount = 1000;
    }
    if (
      (noteText.length > 50 && noteText.split(" ").length < 5) ||
      (noteText.length > 40 && noteText.split(" ")[0].length > 20) ||
      (noteText.length > 25 && noteText.split(" ")[0].length > 20)
    ) {
      notesText.className = "notesText overlapCheckClass  ellipsis";
      notesText.style.width =
        document.querySelector("#notes-container").offsetWidth + "px";
    } else {
      notesText.className = "notesText overlapCheckClass";
    }
    notesText.style.top = topValue - containerTop - 2 + "px";
    notesText.innerHTML = noteText;
    notesText.title = noteText;
    notesText.style.display = "none";
    let notesColor = document.createElement("span");
    notesColor.id = noteId;
    notesColor.className = "notesSpanBlock";
    let countofLinesToBeShifted = 0;
    setTimeout(() => {
      let windowWidth = document.documentElement.clientWidth;
      if (windowWidth < 768) {
        allNotes = document.getElementsByClassName(".notesSpanBlock");
      } else {
        allNotes = document.getElementsByClassName(".notesText");
      }
      let i;
      let lastNoteTopValue = 0;
      let lastNoteHeight = 0;
      setTimeout(() => {
        for (i = 0; i < allNotes.length; i++) {
          lastNoteHeight = allNotes[i].offsetHeight + 5;
          if (
            parseInt(allNotes[i].style.top) == parseInt(notesText.style.top)
          ) {
            lastNoteTopValue = parseInt(allNotes[i].style.top);
            notesText.style.top =
              parseInt(allNotes[i].style.top) - 2 + lastNoteHeight + "px";
            notesColor.style.top =
              parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
            clickableAnchorElement.top =
              parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
          } else if (
            parseInt(allNotes[i].style.top) <
              parseInt(notesText.style.top) + lastNoteHeight &&
            parseInt(allNotes[i].style.top) >
              parseInt(notesText.style.top) - lastNoteHeight
          ) {
            if (parseInt(allNotes[i].style.top) > lastNoteTopValue) {
              lastNoteTopValue = parseInt(allNotes[i].style.top);
              notesText.style.top =
                parseInt(allNotes[i].style.top) - 2 + lastNoteHeight + "px";
              notesColor.style.top =
                parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
              clickableAnchorElement.top =
                parseInt(allNotes[i].style.top) + lastNoteHeight + "px";
            }
          }
        }
      }, timeCount);
      document
        .getElementById("notes-container")
        .appendChild(clickableAnchorElement);
      if (isLink === true) {
        ReactDOM.render(
          <i
            className="fas fa-link linkIcon"
            style={{ top: topValue - containerTop + "px" }}
          />,
          document.getElementById(clickableAnchorElement.id),
        );
      } else {
        ReactDOM.render(
          <i
            className="far fa-file-alt notesIcon"
            style={{ top: topValue - containerTop + "px" }}
          />,
          document.getElementById(clickableAnchorElement.id),
        );
      }
      clickableAnchorElement.appendChild(notesText);
      if (document.getElementById("notesDiv" + noteId) !== null) {
        let currentAnnotationRect = document
          .getElementById("notesDiv" + noteId)
          .getBoundingClientRect();
        let fetchedAnnotationRect = null;
        lastNoteHeight = 0;
        for (i = 0; i < allNotes.length; i++) {
          lastNoteHeight = allNotes[i].offsetHeight + 5;
          fetchedAnnotationRect = document
            .getElementById(allNotes[i].id)
            .getBoundingClientRect();
          if (
            !(
              currentAnnotationRect.right < fetchedAnnotationRect.left ||
              currentAnnotationRect.left > fetchedAnnotationRect.right ||
              currentAnnotationRect.bottom < fetchedAnnotationRect.top ||
              currentAnnotationRect.top > fetchedAnnotationRect.bottom
            )
          ) {
            if (fetchedAnnotationRect.top < currentAnnotationRect.top) {
              if (
                currentAnnotationRect.top - fetchedAnnotationRect.top - 10 <
                parseInt(
                  document
                    .querySelector("#" + allNotes[i].id)
                    .css("line-height"),
                )
              ) {
                if (
                  document.getElementById(allNotes[i].id).innerHTML.length > 1
                ) {
                  document.querySelectorclamp(
                    document.getElementById(allNotes[i].id),
                    {
                      clamp: 1,
                    },
                  );
                }
              } else {
                if (
                  document.getElementById(allNotes[i].id).innerHTML.length > 1
                ) {
                  document.querySelectorclamp(
                    document.getElementById(allNotes[i].id),
                    {
                      clamp: 2,
                    },
                  );
                }
              }
            } else {
              if (
                fetchedAnnotationRect.top - currentAnnotationRect.top - 10 <
                parseInt(
                  document
                    .querySelector("#" + allNotes[i].id)
                    .css("line-height"),
                )
              ) {
                if (
                  document.getElementById(allNotes[i].id).innerHTML.length > 1
                ) {
                  document.querySelectorclamp(
                    document.getElementById(allNotes[i].id),
                    {
                      clamp: 1,
                    },
                  );
                }
              } else {
                if (
                  document.getElementById(allNotes[i].id).innerHTML.length > 1
                ) {
                  document.querySelectorclamp(
                    document.getElementById(allNotes[i].id),
                    {
                      clamp: 2,
                    },
                  );
                }
              }
            }
          }
        }
        if (
          typeof localStorage.getItem("addNoteStartParaId") !== "undefined" &&
          localStorage.getItem("addNoteStartParaId") !== "" &&
          localStorage.getItem("addNoteStartParaId") !== null
        ) {
          let currentAnnotStartPara =
            localStorage.getItem("addNoteStartParaId");
          localStorage.setItem("addNoteStartParaId", "");
          if (currentAnnotStartPara !== "") {
            let currentAnnotParaHasHighlight = document
              .querySelector("#" + currentAnnotStartPara)
              .querySelector("highlight");
            let firstHighlightId = "";
            let firstHighlightPosition = 0;
            let currentNotePosition = 0;
            let currentNoteHeight = 0;
            let currentNoteTotalSpace = 0;
            let clampVal = 1;
            let noteLineHeight = parseInt(
              document.querySelector("#notesDiv" + noteId).style.lineHeight,
            );
            if (currentAnnotParaHasHighlight.length > 1) {
              for (let i = 1; i < currentAnnotParaHasHighlight.length; i++) {
                if (currentAnnotParaHasHighlight[i].id.indexOf("_") === -1) {
                  firstHighlightId = currentAnnotParaHasHighlight[i].id;
                  break;
                }
              }
              if (
                firstHighlightId !== "" &&
                typeof (
                  document.querySelector("#" + firstHighlightId) != "undefined"
                )
              ) {
                if (
                  typeof (
                    document.querySelector("#" + firstHighlightId).offsetTop !==
                    "undefined"
                  )
                ) {
                  firstHighlightPosition = document.querySelector(
                    "#" + firstHighlightId,
                  ).offsetTop;
                  currentNotePosition = document.querySelector(
                    "#" + noteId,
                  ).offsetTop;
                  currentNoteHeight = document.querySelector(
                    "#notesDiv" + noteId,
                  ).clientHeight;
                  currentNoteTotalSpace =
                    currentNotePosition + currentNoteHeight;
                  if (currentNoteTotalSpace > firstHighlightPosition) {
                    localStorage.setItem("addNoteStartParaId", "");
                  }
                }
              }
            } else {
              localStorage.setItem("addNoteStartParaId", "");
              if (
                typeof localStorage.getItem("addNoteNextParaId") !==
                  "undefined" &&
                localStorage.getItem("addNoteNextParaId") !== "" &&
                localStorage.getItem("addNoteNextParaId") !== null
              ) {
                let nextAnnotStartPara =
                  localStorage.getItem("addNoteNextParaId");
                localStorage.setItem("addNoteNextParaId", "");
                if (nextAnnotStartPara !== "") {
                  let currentAnnotParaHasHighlight = document
                    .querySelector("#" + nextAnnotStartPara)
                    .querySelector("highlight");
                  let firstHighlightId = "";
                  let firstHighlightPosition = 0;
                  let currentNotePosition = 0;
                  let currentNoteHeight = 0;
                  let currentNoteTotalSpace = 0;
                  let clampVal = 1;
                  let noteLineHeight = parseInt(
                    document.querySelector("#notesDiv" + noteId).style
                      .lineHeight,
                  );
                  if (currentAnnotParaHasHighlight.length > 0) {
                    for (
                      let i = 0;
                      i < currentAnnotParaHasHighlight.length;
                      i++
                    ) {
                      if (
                        currentAnnotParaHasHighlight[i].id.indexOf("_") === -1
                      ) {
                        firstHighlightId = currentAnnotParaHasHighlight[i].id;
                        break;
                      }
                    }
                    if (
                      typeof (
                        document.querySelector("#" + firstHighlightId) !=
                        "undefined"
                      ) &&
                      typeof (
                        document.querySelector("#" + firstHighlightId)
                          .offsetTop !== "undefined"
                      )
                    ) {
                      firstHighlightPosition = document.querySelector(
                        "#" + firstHighlightId,
                      ).offsetTop;
                      currentNotePosition = document.querySelector(
                        "#" + noteId,
                      ).offsetTop;
                      currentNoteHeight = document.querySelector(
                        "#notesDiv" + noteId,
                      ).clientLeft;
                      currentNoteTotalSpace =
                        currentNotePosition + currentNoteHeight;
                      if (currentNoteTotalSpace > firstHighlightPosition) {
                        if (
                          document.querySelector("#notesDiv" + noteId)
                            .parentElement.offsetTop <
                          document.querySelector("#" + firstHighlightId)
                            .parentElement.offsetTop
                        ) {
                          if (
                            firstHighlightPosition - currentNotePosition >
                            2 * noteLineHeight
                          ) {
                            clampVal = 2;
                          } else if (
                            firstHighlightPosition - currentNotePosition >
                            noteLineHeight
                          ) {
                            clampVal = 1;
                          }
                          if (
                            document.querySelector("#notesDiv" + noteId)
                              .innerHTML.length > 10
                          ) {
                            $(document.getElementById("notesDiv" + noteId), {
                              clamp: clampVal,
                            });
                          }
                        }
                        localStorage.setItem("addNoteNextParaId", "");
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }, timeCount);
    setTimeout(() => {}, 2000);
  };
  const getChapterListForOutline = async () => {
    setLoading(true);
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadChapterId: "",
          lastViewedOutlineId: "",
          pageNavigatingTo: "EReader",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadParagraphId: "para01",
          lastReadSubSectionId: "subsec01",
          lastReadBookId: props.bookVO.bookId,
          lastViewedOutlineType: "chapterOutline",
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      outlineVO: {
        bookId: props.bookVO.bookId,
        recentNotesFlag: "allNotes",
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    try {
      const data = await (
        await fetch(
          `${localStorage.getItem("ENV")}/manageOutlineService/getOutlineNotes`,
          requestOptions1,
        )
      ).json();
      if (data) {
        if (data.status === "true") {
          let currentCustomOutlineVOList = [];
          if (data.outlineVO && data.outlineVO.chapterOutlineVO) {
            let chapterList = Array.isArray(data.outlineVO.chapterOutlineVO)
              ? data.outlineVO.chapterOutlineVO
              : [data.outlineVO.chapterOutlineVO];
            if (data.outlineVO.customOutlineVO !== undefined)
              currentCustomOutlineVOList = Array.isArray(
                data.outlineVO.customOutlineVO,
              )
                ? data.outlineVO.customOutlineVO
                : [data.outlineVO.customOutlineVO];
            var option = {};
            option.chapterId = "EMPTY_SUPP";
            option.navbarTitle = "";
            if (bookVO.chapterType !== "chapter") {
              chapterList.unshift(option);
            }
            setChapterDrpDwnList(chapterList);
          }
          setCurrentState({
            ...currentState,
            customOutlineVOList: currentCustomOutlineVOList,
            currentChapterNavTitle: props.bookVO.navbarTitle,
          });
        }
      } else if (data.wkErrorCode) {
        handleException(data);
      }
      setLoading(false);
    } catch (error) {
      console.error(
        "There has been a problem with your fetch operation:",
        error,
      );
    }
  };
  const jumpToTextOutline = (e, outlineId) => {
    let dd = document.getElementById("outlineChpaterListDrpDwn");
    if (dd.selectedOptions[0]) {
      var sectionId = outlineId.replaceAll("outline_", "");
      if (dd.selectedOptions[0].value === props.bookVO.chapterId) {
        var section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView();
          window.history.replaceState(
            null,
            null,
            "/" +
              localStorage.getItem("reactNodeName") +
              history.location.pathname +
              "#" +
              sectionId,
          );
          window.scroll(0, 0);
        } else
          history.push(
            `/read/users/${userVO.userId}/books/${props.bookVO.bookISBN}/${dd.selectedOptions[0].value}#${sectionId}`,
          );
      } else {
        history.push(
          `/read/users/${userVO.userId}/books/${props.bookVO.bookISBN}/${dd.selectedOptions[0].value}#${sectionId}`,
        );
      }
    } else {
      history.push(
        `/read/users/${userVO.userId}/books/${props.bookVO.bookISBN}/${dd.selectedOptions[0] && dd.selectedOptions[0].value}#${sectionId}`,
      );
    }
    if (document.getElementById("popover-basic"))
      document.getElementById("popover-basic").style.display = "none";
    if (document.getElementById("outlineIcon"))
      document.getElementById("outlineIcon").focus();
  };
  const onChangeChapterEvent = (e) => {
    if (e.target.value && e.target.value !== "EMPTY_SUPP") {
      if (document.getElementById("outlineNotesSection")) {
        var dynamicNode = document.querySelectorAll('*[id^="outline_"]');
        for (var i = 0; i < dynamicNode.length; i++) {
          if (dynamicNode[i] && dynamicNode[i].parentNode) {
            dynamicNode[0].innerHTML = "";
            dynamicNode[0].className = "";
          }
        }
      }
      const selectedChapterId = e.target.value;
      latestChapterIdRef.current = selectedChapterId;

      // Clear current outline immediately and abort any in-flight outline request.
      // This prevents a previous chapter response from repainting stale highlights.
      if (chapterLayoutAbortController.current) {
        chapterLayoutAbortController.current.abort();
      }
      setSectionVOList([]);

      setCurrentState({
        ...currentState,
        currentChapterId: selectedChapterId,
        currentChapterNavTitle:
          e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text,
      });
    }
  };
  const handleChapterJumpToText = (e) => {
    let dd = document.getElementById("outlineChpaterListDrpDwn");
    setRouteChangeMsg(
      `Jumping to ${currentState.currentChapterNavTitle} Outlines`,
    );
    setTimeout(() => {
      if (dd && dd.selectedOptions[0] && dd.selectedOptions[0].value) {
        if (params.chapterid !== dd.selectedOptions[0].value) {
          history.push(
            `/read/users/${userVO.userId}/books/${props.bookVO.bookISBN}/${dd.selectedOptions[0].value}`,
          );
        }
      }
    }, 500);
    localStorage.setItem("ChapterContentFocus", "true");
  };
  const EditSharedLink = (e, outlineId, noteStatus) => {
    let currentLink = document
      .querySelector("#" + outlineId)
      .querySelector(".annotationLink")
      .querySelector(".profLinkUrl").innerText;
    document
      .querySelector("#" + outlineId)
      .querySelector(".annotationLink")
      .querySelector(".profLinkUrl").style.display = "none";
    var element = document.createElement("textarea");
    element.setAttribute("type", "text");
    element.setAttribute("name", "outLineProfUrl");
    element.className = "textAreaNote";
    element.id = "annotationLinkURL";
    element.value = currentLink;
    element.onchange = handleChangeNote;
    document
      .querySelector("#" + outlineId)
      .querySelector(".annotationLink")
      .appendChild(element);
    document
      .querySelector("#" + outlineId)
      .querySelector("#annotationLinkURL")
      .focus();
    document
      .getElementById("annotationLinkURL")
      .addEventListener("blur", () => handleBlurEditUrl(e, outlineId));
  };
  const handleBlurEditUrl = (e, outlineId) => {
    let linkVal = outLineProfUrl.current;
    linkShareFlagStatus1 = isSharedLink ? "true" : "false";
    if (linkVal.trim() === "") {
      let rParent = document.getElementById(outlineId);
      let rChild = rParent.childNodes[1];
      isSharedLink === true
        ? rChild.removeChild(rChild.childNodes[3])
        : rChild.removeChild(rChild.childNodes[2]);
      document
        .querySelector("#" + outlineId)
        .querySelector(".annotationLink")
        .querySelector(".profLinkUrl").style.display = "inline-block";
    } else {
      let rParent = document.getElementById(outlineId);
      let rChild = rParent.childNodes[1];
      isSharedLink === true
        ? rChild.removeChild(rChild.childNodes[3])
        : rChild.removeChild(rChild.childNodes[2]);
      handleUpdateLink(e, outlineId, linkShareFlagStatus1);
    }
  };
  const handleUpdateLink = (e, outlineId, linkShareFlagStatus1) => {
    const { bookVO, userVO, chapterId } = props;
    let updatedLink = outLineProfUrl.current.toString();
    let linkStatus = isSharedLink.toString();
    let linkDescription = document
      .getElementById("outline_" + localStorage.getItem("outid"))
      .getAttribute("linkdescription");
    let sectID5 = "";
    let AnnotationID5 = document.getElementById(
      "outline_" + localStorage.getItem("outid"),
    );
    if (AnnotationID5) {
      if (AnnotationID5.parentElement.getAttribute("sectionid") !== null) {
        sectID5 = AnnotationID5.parentElement.getAttribute("sectionid");
      } else if (
        AnnotationID5.parentElement.parentElement.getAttribute("sectionid") !==
        null
      ) {
        sectID5 =
          AnnotationID5.parentElement.parentElement.getAttribute("sectionid");
      }
    }
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadSectionId: "",
          pageNavigatingTo: "EReader",
          pageNavigatingFrom: "EReader",
          lastActivityCode: "BOOKSHELF",
          lastReadBookId: bookVO.bookId,
          lastReadPageNum: bookVO.lastReadPageNum,
          lastReadChapterId: bookVO.chapterTitle,
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      annotationVO: {
        sectionId: sectID5,
        chapterId: chapterId,
        bookId: bookVO.bookId,
        linkDescription: linkDescription,
        chapterTitle: bookVO.chapterTitle,
        linkShareFlag: linkShareFlagStatus1,
        linkUrl: outLineProfUrl.current.toString(),
        annotationId: localStorage.getItem("outid"),
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageAnnotationService/updateChapterLink`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then(function (data) {
        if (data.status === "true") {
          if (typeof data.sessionAuthenticationToken != "undefined") {
            localStorage.setItem(
              "sessionAuthenticationToken",
              data.sessionAuthenticationToken,
            );
          }
          reqData.annotationVO.annotationStatus = "updatedLink";
          reqData.annotationVO.dppContentType = "link";
          onHandlesetReduxAnnotationVO(reqData.annotationVO);
          document
            .getElementById("outline_" + localStorage.getItem("outid"))
            .querySelector(".annotationLink")
            .querySelector(".profLinkUrl").innerText =
            outLineProfUrl.current.toString();
          document
            .querySelector("#" + outlineId)
            .querySelector(".annotationLink")
            .querySelector(".profLinkUrl").style.display = "inline-block";
          let relatedAnchorTagsToRepaint = document.querySelectorAll(
            `anchortag[id^="${localStorage.getItem("outid")}"]`,
          );
          for (let j = 0; j < relatedAnchorTagsToRepaint.length; j++) {
            relatedAnchorTagsToRepaint[j].setAttribute(
              "createdlinksharestatus",
              linkShareFlagStatus1,
            );
            relatedAnchorTagsToRepaint[j].setAttribute(
              "createdlinkurl",
              updatedLink,
            );
          }
          let yValue = document
            .getElementById(localStorage.getItem("outid"))
            .getBoundingClientRect().top;
          if (linkShareFlagStatus1 === "false") {
            let notesTextClassElements =
              document.querySelectorAll(".linksIcon");
            for (let i = 0; i < notesTextClassElements.length; i++) {
              if (
                notesTextClassElements[i].id.substring(
                  7,
                  notesTextClassElements[i].id.length,
                ) === localStorage.getItem("outid")
              ) {
                notesTextClassElements[i].parentNode.removeChild(
                  notesTextClassElements[i],
                );
                displayNotesOnRight(
                  "",
                  localStorage.getItem("outid"),
                  yValue,
                  true,
                );
                break;
              }
            }
          } else if (linkShareFlagStatus1 === "true") {
            let notesTextClassElements =
              document.getElementsByClassName("notesText");
            for (let i = 0; i < notesTextClassElements.length; i++) {
              if (
                notesTextClassElements[i].id.substring(
                  8,
                  notesTextClassElements[i].id.length,
                ) === localStorage.getItem("outid")
              ) {
                notesTextClassElements[i].parentNode.remove();
                displayLinksOnLeft(
                  localStorage.getItem("outid"),
                  yValue,
                  updatedLink,
                  "",
                  linkShareFlagStatus1,
                  "true",
                );
                break;
              }
            }
          }
        } else {
          if (data.httpErrorCode === "400") {
            setNotificationState({
              notificationOpen: true,
              notificationContent: data.errorMessg,
            });
            document
              .querySelector("#" + outlineId)
              .querySelector(".annotationLink")
              .querySelector(".profLinkUrl").style.display = "inline-block";
          } else if (data.wkErrorCode) {
            handleException(data);
          }
        }
        if (document.getElementById("popover-basic"))
          document.getElementById("popover-basic").style.display = "none";
        if (document.getElementById("outlineIcon"))
          document.getElementById("outlineIcon").focus();
      })
      .catch((error) => {
        if (document.getElementById("popover-basic"))
          document.getElementById("popover-basic").style.display = "none";
        setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const RemoveProfessorLink = (e, outlineId, linkShareFlagStatus) => {
    setLoading(true);
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadSectionId: "",
          pageNavigatingTo: "EReader",
          lastReadChapterId: chapterId,
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          lastReadBookId: bookVO.bookId,
          lastReadPageNum: bookVO.lastReadPageNum,
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      annotationVO: {
        chapterId: chapterId,
        bookId: bookVO.bookId,
        chapterTitle: bookVO.chapterTitle,
        annotationId: localStorage.getItem("outid"),
      },
    };
    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    fetch(
      `${localStorage.getItem("ENV")}/manageAnnotationService/deleteChapterLink`,
      requestOptions1,
    )
      .then((response) => response.json())
      .then(function (data) {
        if (data.status === "true") {
          if (typeof data.sessionAuthenticationToken != "undefined") {
            localStorage.setItem(
              "sessionAuthenticationToken",
              data.sessionAuthenticationToken,
            );
          }
          let outlineLinkRemove = "outline_" + localStorage.getItem("outid");
          if (document.getElementById(outlineLinkRemove) !== null)
            document.getElementById(outlineLinkRemove).remove();
          var allLinkTag = document.querySelectorAll(
            `anchortag[id^="${localStorage.getItem("outid")}"]`,
          );
          for (var i = 0; i < allLinkTag.length; i++) {
            var linkSpanTag = document.getElementById(allLinkTag[i].id);
            let parent = linkSpanTag.parentNode;
            while (linkSpanTag.firstChild)
              parent.insertBefore(linkSpanTag.firstChild, linkSpanTag);
            parent.removeChild(linkSpanTag);
          }
          var linkIconClassElements = document.querySelectorAll(".linksIcon");
          for (var i = 0; i < linkIconClassElements.length; i++) {
            if (
              linkIconClassElements[i].id.substring(
                7,
                linkIconClassElements[i].id.length,
              ) === localStorage.getItem("outid")
            ) {
              linkIconClassElements[i].parentNode.removeChild(
                linkIconClassElements[i],
              );
              break;
            }
          }
          let notesTextClassElements =
            document.getElementsByClassName("notesText");
          for (let i = 0; i < notesTextClassElements.length; i++) {
            if (
              notesTextClassElements[i].id.substring(
                8,
                notesTextClassElements[i].id.length,
              ) === localStorage.getItem("outid")
            ) {
              notesTextClassElements[i].parentNode.remove();
              break;
            }
          }
        } else if (data.wkErrorCode) {
          handleException(data);
        }
        if (document.getElementById("popover-basic"))
          document.getElementById("popover-basic").style.display = "none";
        if (document.getElementById("outlineIcon"))
          document.getElementById("outlineIcon").focus();
        setLoading(false);
      })
      .catch((error) => {
        if (document.getElementById("popover-basic"))
          document.getElementById("popover-basic").style.display = "none";
        setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const handleSharedLinkFlag = (e, outlineId) => {
    let linkFlag =
      e.currentTarget.innerText &&
      e.currentTarget.innerText.replace(/ /g, "").toLowerCase();
    if (linkFlag === "sharelink") {
      linkShareFlagStatus1 = "true";
      handleUpdateLink(e, outlineId, linkShareFlagStatus1);
    } else if (linkFlag === "makeprivate") {
      linkShareFlagStatus1 = "false";
      handleUpdateLink(e, outlineId, linkShareFlagStatus1);
    }
  };
  const displayLinksOnLeft = (
    linkId,
    topValue,
    urlText,
    urlComment,
    checkboxStatus,
    linkEditingForproffessor,
  ) => {
    if (document.getElementById("linkAnchorElement" + linkId)) {
      document.getElementById("linkAnchorElement" + linkId).remove();
    }
    let lineHeight = document.querySelector(".ereader-content")
      ? document.querySelector(".ereader-content").style.lineHeight
      : 0;
    let containerTop = document
      .getElementById("links-container")
      .getBoundingClientRect().top;
    let clickableAnchorElement = document.createElement("A");
    clickableAnchorElement.id = "linkAnchorElement" + linkId;
    let linkIcon = document.createElement("IMG");
    linkIcon.id = "linkDiv" + linkId;
    linkIcon.className = "linksIcon display-inline-block";
    linkIcon.style.top = topValue - containerTop - 2 + "px";
    linkIcon.src = shareLinkIcon;
    linkIcon.style.width = "30px";
    linkIcon.style.height = "auto";
    linkIcon.style.position = "absolute";
    if (urlComment !== undefined && urlComment !== null && urlComment !== "") {
      linkIcon.setAttribute(
        "urlComments",
        urlComment.replace(/</g, "&lt;").replace(/>/g, "&gt;"),
      );
    } else {
      linkIcon.setAttribute("urlComments", "");
    }
    linkIcon.setAttribute("urlText", urlText);
    linkIcon.setAttribute("shareLinkChecked", checkboxStatus);
    linkIcon.setAttribute("linkEditingForproffessor", linkEditingForproffessor);
    let countofLinesToBeShifted = 0;
    let allLinks = Array.from(document.querySelectorAll(".linksIcon"));
    allLinks.sort(function (a, b) {
      if (a.style.top > b.style.top) return 1;
      if (a.style.top < b.style.top) return -1;
      return 0;
    });
    let i;
    let lastNoteTopValue = 0;
    for (i = 0; i < allLinks.length; i++) {
      if (
        parseInt(allLinks[i].style.top) <
          parseInt(linkIcon.style.top) + parseInt(lineHeight) &&
        parseInt(allLinks[i].style.top) >
          parseInt(linkIcon.style.top) - parseInt(lineHeight)
      ) {
        if (parseInt(allLinks[i].style.top) > lastNoteTopValue) {
          lastNoteTopValue = parseInt(allLinks[i].style.top);
          linkIcon.style.top =
            parseInt(allLinks[i].style.top) + 7 + parseInt(lineHeight) + "px";
          clickableAnchorElement.top =
            parseInt(allLinks[i].style.top) + parseInt(lineHeight) + "px";
        }
      }
    }
    clickableAnchorElement.appendChild(linkIcon);
    document
      .getElementById("links-container")
      .appendChild(clickableAnchorElement);
    let allrTsIcon = document.querySelectorAll(".rTsIcon");
    for (let j = 0; j < allrTsIcon.length; j++) {
      let differenceInTop = 0;
      if (parseInt(linkIcon.style.top) >= parseInt(allrTsIcon[j].style.top)) {
        differenceInTop =
          parseInt(linkIcon.style.top) - parseInt(allrTsIcon[j].style.top);
        if (differenceInTop < 20) {
          allrTsIcon[j].remove();
          allrTsIcon[j].style.top =
            parseInt(linkIcon.style.top) + 7 + parseInt(lineHeight) + "px";
          document.getElementById("links-container").appendChild(allrTsIcon[j]);
        }
      }
    }
    let currentAnnotationRect = document.getElementById("linkDiv" + linkId)
      ? document.getElementById("linkDiv" + linkId).getBoundingClientRect()
      : 0;
    let fetchedAnnotationRect = null;
    for (i = 0; i < allLinks.length; i++) {
      fetchedAnnotationRect = document.getElementById(allLinks[i].id)
        ? document.getElementById(allLinks[i].id).getBoundingClientRect()
        : 0;
      if (
        !(
          currentAnnotationRect.right < fetchedAnnotationRect.left ||
          currentAnnotationRect.left > fetchedAnnotationRect.right ||
          currentAnnotationRect.bottom < fetchedAnnotationRect.top ||
          currentAnnotationRect.top > fetchedAnnotationRect.bottom
        )
      ) {
      }
    }
  };
  const displayBriefOnRight = (
    briefId,
    briefColor,
    topValue,
    labelText,
    briefNote,
  ) => {
    if (labelText != null && labelText != undefined && labelText != "") {
      labelText = labelText.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    if (document.querySelector("#briefAnchorElement" + briefId)) {
      document.querySelector("#briefAnchorElement" + briefId).remove();
    }
    let lineHeight = document.querySelector(".ereader-content")
      ? document.querySelector(".ereader-content").style.lineHeight
      : undefined;
    let containerTop = document.getElementById("notes-container")
      ? document.getElementById("notes-container").getBoundingClientRect().top
      : 0;
    let clickableAnchorElement = document.createElement("A");
    clickableAnchorElement.id = "briefAnchorElement" + briefId;
    clickableAnchorElement.setAttribute("labelName", labelText);
    clickableAnchorElement.setAttribute("briefNote", briefNote);
    clickableAnchorElement.style.color = "#333333";
    let bLabelText = document.createElement("div");
    bLabelText.id = "labelDiv" + briefId;
    bLabelText.className = "labelText  ellipsis";
    bLabelText.style.width =
      document.querySelector("#notes-container").clientWidth + "px";
    bLabelText.style.top = topValue - containerTop - 2 + "px";
    bLabelText.innerHTML = labelText;
    bLabelText.setAttribute("labelName", labelText);
    bLabelText.setAttribute("briefNote", briefNote);
    bLabelText.title = labelText;
    let bNotesText = document.createElement("div");
    bNotesText.id = "notesDiv" + briefId;
    bNotesText.innerHTML = briefNote;
    bNotesText.setAttribute("labelName", labelText);
    bNotesText.setAttribute("briefNote", briefNote);
    bNotesText.title = briefNote;
    if (
      (briefNote.length > 50 && briefNote.split(" ").length < 5) ||
      (briefNote.length > 40 && briefNote.split(" ")[0].length > 20) ||
      (briefNote.length > 25 && briefNote.split(" ")[0].length > 20)
    ) {
      bNotesText.className = "briefNotesText  ellipsis";
      bNotesText.style.width =
        document.querySelector("#notes-container").clientWidth + "px";
    } else {
      bNotesText.className = "briefNotesText";
    }
    if (bLabelText) {
      bNotesText.style.top = bLabelText.style.top + parseInt(lineHeight) + "px";
    } else {
      bNotesText.style.top = topValue - containerTop - 2 + "px";
    }
    let labelNoteWrapper = document.createElement("div");
    labelNoteWrapper.id = "briefWrapDiv" + briefId;
    labelNoteWrapper.className = "labelNoteWrapper overlapCheckClass";
    labelNoteWrapper.className = "labelNoteWrapper overlapCheckClass";
    labelNoteWrapper.setAttribute("labelName", labelText);
    labelNoteWrapper.setAttribute("briefNote", briefNote);
    labelNoteWrapper.style.top = topValue - containerTop - 2 + "px";
    labelNoteWrapper.appendChild(bLabelText);
    labelNoteWrapper.appendChild(bNotesText);
    let briefNColor = document.createElement("span");
    briefNColor.id = "colSpan" + briefId;
    briefNColor.className = "briefSpanBlock";
    briefNColor.setAttribute(
      "style",
      "background-color:" +
        briefColor +
        " !important;" +
        " top:" +
        (topValue - containerTop) +
        "px" +
        ";",
    );
    briefNColor.style.top = labelNoteWrapper.style.top;
    let countOfBriefInChapter = 300;
    if (localStorage.getItem("briefAnnotationListForChapter") !== null) {
      countOfBriefInChapter = localStorage
        .getItem("briefAnnotationListForChapter")
        .split(",").length;
    } else {
      countOfBriefInChapter = 1000;
    }
    if (countOfBriefInChapter < 50) {
      timeCount = 1;
    } else if (countOfBriefInChapter > 50 && countOfBriefInChapter <= 150) {
      timeCount = 800;
    } else {
      timeCount = 1000;
    }
    setTimeout(() => {
      let allBrief = Array.from(document.querySelectorAll(".labelNoteWrapper"));
      if (typeof allBrief !== "undefined") {
        if (allBrief.length > 0) {
          allBrief.sort(function (a, b) {
            if (parseInt(a.style.top) > parseInt(b.style.top)) return 1;
            if (parseInt(a.style.top) < parseInt(b.style.top)) return -1;
            return 0;
          });
        }
      }
      let i;
      let lastBriefTopValue = 0;
      let lastBriefHeight = 0;
      setTimeout(() => {
        for (i = 0; i < allBrief.length; i++) {
          lastBriefHeight = allBrief[i].offsetHeight + 5;
          if (
            parseInt(allBrief[i].style.top) ==
            parseInt(labelNoteWrapper.style.top)
          ) {
            lastBriefTopValue = parseInt(allBrief[i].style.top);
            labelNoteWrapper.style.top =
              parseInt(allBrief[i].style.top) - 2 + lastBriefHeight + "px";
            briefNColor.style.top =
              parseInt(allBrief[i].style.top) + lastBriefHeight + "px";
            clickableAnchorElement.top =
              parseInt(allBrief[i].style.top) + lastBriefHeight + "px";
          } else if (
            parseInt(allBrief[i].style.top) <
              parseInt(labelNoteWrapper.style.top) + lastBriefHeight &&
            parseInt(allBrief[i].style.top) >
              parseInt(labelNoteWrapper.style.top) - lastBriefHeight
          ) {
            if (parseInt(allBrief[i].style.top) > lastBriefTopValue) {
              lastBriefTopValue = parseInt(allBrief[i].style.top);
              labelNoteWrapper.style.top =
                parseInt(allBrief[i].style.top) - 2 + lastBriefHeight + "px";
              briefNColor.style.top =
                parseInt(allBrief[i].style.top) + lastBriefHeight + "px";
              clickableAnchorElement.top =
                parseInt(allBrief[i].style.top) + lastBriefHeight + "px";
            }
          }
        }
      }, timeCount);
      document
        .getElementById("notes-container")
        .appendChild(clickableAnchorElement);
      ReactDOM.render(
        <i
          className="far fa-file-alt notesIcon"
          style={{ top: topValue - containerTop + "px" }}
        />,
        document.getElementById(clickableAnchorElement.id),
      );
      clickableAnchorElement.appendChild(briefNColor);
      if (document.getElementById("briefWrapDiv" + briefId) !== null) {
        let currentAnnotationRect = document.getElementById(
          "briefWrapDiv" + briefId,
        )
          ? document
              .getElementById("briefWrapDiv" + briefId)
              .getBoundingClientRect()
          : 0;
        let fetchedAnnotationRect = null;
        lastBriefHeight = 0;
        let elemToClamp = null;
        for (i = 0; i < allBrief.length; i++) {
          lastBriefHeight = allBrief[i].offsetHeight + 5;
          elemToClamp = "notesDiv" + allBrief[i].id.slice(12);
          fetchedAnnotationRect = document
            .getElementById(allBrief[i].id)
            .getBoundingClientRect();
          if (
            !(
              currentAnnotationRect.right < fetchedAnnotationRect.left ||
              currentAnnotationRect.left > fetchedAnnotationRect.right ||
              currentAnnotationRect.bottom < fetchedAnnotationRect.top ||
              currentAnnotationRect.top > fetchedAnnotationRect.bottom
            )
          ) {
            if (fetchedAnnotationRect.top < currentAnnotationRect.top) {
              if (
                currentAnnotationRect.top - fetchedAnnotationRect.top - 10 <
                parseInt(lastBriefHeight)
              ) {
                if (
                  parseInt(lastBriefHeight) <
                  parseInt(
                    document.querySelector("#" + allBrief[i].id).style
                      .lineHeight,
                  )
                ) {
                } else {
                  document.getElementById(elemToClamp).style.width =
                    document.querySelector("#notes-container").clientWidth +
                    "px";
                  document.getElementById(elemToClamp).className =
                    "briefNotesText  ellipsis";
                }
              } else {
                if (
                  parseInt(lastBriefHeight) <
                  parseInt(
                    document.querySelector("#" + allBrief[i].id).style
                      .lineHeight,
                  )
                ) {
                } else {
                  document.getElementById(elemToClamp).style.width =
                    document.querySelector("#notes-container").clientWidth +
                    "px";
                  document.getElementById(elemToClamp).className =
                    "briefNotesText  ellipsis";
                }
              }
            } else {
              if (
                fetchedAnnotationRect.top - currentAnnotationRect.top - 10 <
                parseInt(lastBriefHeight)
              ) {
                if (
                  parseInt(lastBriefHeight) <
                  parseInt(
                    document.querySelector("#" + allBrief[i].id).style
                      .lineHeight,
                  )
                ) {
                } else {
                  document.getElementById(elemToClamp).style.width =
                    document.querySelector("#notes-container").clientWidth +
                    "px";
                  document.getElementById(elemToClamp).className =
                    "briefNotesText  ellipsis";
                }
              } else {
                if (
                  parseInt(lastBriefHeight) <
                  parseInt(
                    document.querySelector("#" + allBrief[i].id).style
                      .lineHeight,
                  )
                ) {
                } else {
                  document.getElementById(elemToClamp).style.width =
                    document.querySelector("#notes-container").clientWidth +
                    "px";
                  document.getElementById(elemToClamp).className =
                    "briefNotesText  ellipsis";
                }
              }
            }
          }
        }
        if (
          typeof localStorage.getItem("addBriefStartParaId") !== "undefined" &&
          localStorage.getItem("addBriefStartParaId") !== "" &&
          localStorage.getItem("addBriefStartParaId") !== null
        ) {
          let currentAnnotStartPara = localStorage.getItem(
            "addBriefStartParaId",
          );
          localStorage.setItem("addBriefStartParaId", "");
          if (currentAnnotStartPara !== "") {
            let currentAnnotParaHasHighlight = document
              .querySelector("#" + currentAnnotStartPara)
              .querySelectorAll("briefstag");
            let firstHighlightId = "";
            let firstHighlightPosition = 0;
            let currentNotePosition = 0;
            let currentNoteHeight = 0;
            let currentNoteTotalSpace = 0;
            let clampVal = 1;
            let noteLineHeight = parseInt(
              document.querySelector("#notesDiv" + briefId).style.lineHeight,
            );
            if (currentAnnotParaHasHighlight.length > 1) {
              for (let i = 1; i < currentAnnotParaHasHighlight.length; i++) {
                if (currentAnnotParaHasHighlight[i].id.indexOf("_") === -1) {
                  firstHighlightId = currentAnnotParaHasHighlight[i].id;
                  break;
                }
              }
              if (
                firstHighlightId !== "" &&
                typeof (
                  document.querySelector("#" + firstHighlightId) != "undefined"
                )
              ) {
                if (
                  typeof (
                    document.querySelector("#" + firstHighlightId).offsetTop !==
                    "undefined"
                  )
                ) {
                  firstHighlightPosition = document.querySelector(
                    "#" + firstHighlightId,
                  ).offsetTop;
                  currentNotePosition = document.querySelector(
                    "#" + briefId,
                  ).offsetTop;
                  currentNoteHeight = document.querySelector(
                    "#briefWrapDiv" + briefId,
                  ).clientHeight;
                  currentNoteTotalSpace =
                    currentNotePosition + currentNoteHeight;
                  if (currentNoteTotalSpace > firstHighlightPosition) {
                    if (
                      parseInt(
                        document
                          .querySelector("#" + briefId)
                          .getAttribute("startOffset"),
                      ) <
                      parseInt(
                        document
                          .querySelector("#" + firstHighlightId)
                          .getAttribute("startOffset"),
                      )
                    ) {
                      if (
                        firstHighlightPosition - currentNotePosition >
                        2 * noteLineHeight
                      ) {
                        clampVal = 1;
                      } else if (
                        firstHighlightPosition - currentNotePosition >
                        noteLineHeight
                      ) {
                        clampVal = 1;
                      }
                      if (
                        document.querySelector("#notesDiv" + briefId).innerHTML
                          .length > 10
                      ) {
                      }
                    }
                    localStorage.setItem("addBriefStartParaId", "");
                  }
                }
              }
            } else {
              localStorage.setItem("addBriefStartParaId", "");
              if (
                typeof localStorage.getItem("addBriefNextParaId") !==
                  "undefined" &&
                localStorage.getItem("addBriefNextParaId") !== "" &&
                localStorage.getItem("addBriefNextParaId") !== null
              ) {
                let currentAnnotStartPara =
                  localStorage.getItem("addBriefNextParaId");
                localStorage.setItem("addBriefNextParaId", "");
                if (currentAnnotStartPara !== "") {
                  let currentAnnotParaHasHighlight = document
                    .querySelector("currentAnnotStartPara")
                    .querySelectorAll("briefstag");
                  let firstHighlightId = "";
                  let firstHighlightPosition = 0;
                  let currentNotePosition = 0;
                  let currentNoteHeight = 0;
                  let currentNoteTotalSpace = 0;
                  let clampVal = 1;
                  let noteLineHeight = parseInt(
                    document.querySelector("#notesDiv" + briefId).style
                      .lineHeight,
                  );
                  if (currentAnnotParaHasHighlight.length > 0) {
                    for (
                      let i = 0;
                      i < currentAnnotParaHasHighlight.length;
                      i++
                    ) {
                      if (
                        currentAnnotParaHasHighlight[i].id.indexOf("_") === -1
                      ) {
                        firstHighlightId = currentAnnotParaHasHighlight[i].id;
                        break;
                      }
                    }
                    if (
                      typeof (
                        document.querySelector("#" + firstHighlightId) !=
                        "undefined"
                      )
                    ) {
                      if (
                        typeof (
                          document.querySelector("#" + firstHighlightId)
                            .offsetTop !== "undefined"
                        )
                      ) {
                        firstHighlightPosition = document.querySelector(
                          "#" + firstHighlightId,
                        ).offsetTop;
                        currentNotePosition = document.querySelector(
                          "#" + briefId,
                        ).offsetTop;
                        currentNoteHeight = document.querySelector(
                          "#briefWrapDiv" + briefId,
                        ).clientHeight;
                        currentNoteTotalSpace =
                          currentNotePosition + currentNoteHeight;
                        if (currentNoteTotalSpace > firstHighlightPosition) {
                          if (
                            firstHighlightPosition - currentNotePosition >
                            2 * noteLineHeight
                          ) {
                            clampVal = 2;
                          } else if (
                            firstHighlightPosition - currentNotePosition >
                            noteLineHeight
                          ) {
                            clampVal = 1;
                          }
                          if (
                            document.getElementById(briefId) &&
                            document.getElementById(briefId).length > 10
                          ) {
                          }
                          localStorage.setItem("addBriefNextParaId", "");
                        }
                        if (
                          document.getElementById(briefId) &&
                          document.getElementById(briefId).length > 10
                        ) {
                        }
                        localStorage.setItem("addBriefNextParaId", "");
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }, timeCount);
    addingBrief = false;
    setTimeout(() => {}, 2000);
  };
  const handleBriefNote = (e, outlineId, noteStatus, type) => {
    if (e.key === "Enter") {
      AnnotateFromOutline(e, outlineId, noteStatus, type);
    }
  };
  const handleChapterJmpToText = (e, outlineId) => {
    if (e.key === "Enter") {
      jumpToTextOutline(e, outlineId);
    }
  };
  const handleChapterJumpToTextFunc = (e) => {
    if (e.key === "Enter") {
      handleChapterJumpToText(e);
    }
  };
  const handleEditSharedLink = (e, outlineId, isSharedLink) => {
    if (e.key === "Enter") {
      EditSharedLink(e, outlineId, isSharedLink);
    }
  };
  const handleSharedLinkFlagonEnter = (e, outlineId) => {
    if (e.key === "Enter") {
      handleSharedLinkFlag(e, outlineId);
    }
  };
  const handleRemoveProfessorLink = (e, outlineId, isSharedLink) => {
    if (e.key === "Enter") {
      RemoveProfessorLink(e, outlineId, isSharedLink);
    }
  };
  const onHandleClickLink = (url) => window.open(url, "_blank");
  // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
  const focusFirstOutlinePopoverItem = () => {
    // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
    const firstItem = document.querySelector(".outlinePopover [tabindex='0']");
    if (firstItem) firstItem.focus();
  };
  // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
  const handleOutlinePopoverKeyDown = (e) => {
    // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
    if (e.key === "Escape") {
      const trigger = document.querySelector(
        `#${outlineId.current} [role='button']`,
      );
      if (trigger) trigger.focus();
    }
  };
  const popover = (
    // <Popover id="popover-basic" className="outlinePopover">
    <Popover
      id="popover-basic"
      className="outlinePopover"
      // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
      role="dialog"
      // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
      aria-label="Annotation options"
      // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
      onKeyDown={handleOutlinePopoverKeyDown}
    >
      <Popover.Content>
        <div
          className="mLeftTen outLinePopover"
          outlineId={outlineId.current}
          onClick={(e) =>
            AnnotateFromOutline(e, outlineId.current, noteStatus, "annotation")
          }
        >
          <span
            tabIndex="0"
            onKeyDown={(e) =>
              handleBriefNote(e, outlineId.current, noteStatus, "annotation")
            }
          >
            {noteStatus ? "Edit Annotation" : "Annotate"}
          </span>
        </div>
        <div className="mLeftTen outLinePopover">
          <span
            tabIndex="0"
            onKeyDown={(e) => handleChapterJmpToText(e, outlineId.current)}
            onClick={(e) => jumpToTextOutline(e, outlineId.current)}
          >
            {" "}
            Jump to text
          </span>
        </div>
        <div className="highlighter-colors">
          <div className="highlight-outlinePopover">Change highlight color</div>
          <div className="color-pallete">
            {outlineColorList.map((cc, index) => {
              if (cc.id === "underLineOut") {
                return colorsState.highlightQuickUnderLine ? (
                  <GrFormClose
                    key={index}
                    id="underLineOut"
                    className="underline_rt"
                    onClick={(e) => removeHighLightColor(e)}
                  />
                ) : (
                  <button
                    key={index}
                    className="underline_rt"
                    style={{ background: "" }}
                    aria-label="underLine"
                    colorcode="underLine"
                    title="underLine"
                    onClick={(e) => colorBtnPressed(e, "underLine")}
                    id="underLineOut"
                  >
                    <AiOutlineUnderline />
                  </button>
                );
              } else {
                return (
                  <button
                    key={index}
                    className="noButton select-marker colorButton"
                    style={{ background: cc.color }}
                    aria-label={cc.title}
                    title={cc.title}
                    // onClick={(e) =>
                    //   colorsState[cc.stateValue]
                    //     ? removeHighLightColor(e)
                    //     : colorBtnPressed(e, cc.color)
                    // }
                    onClick={(e) => {
                      const currentId =
                        "outline_" + localStorage.getItem("outid");
                      const currentElement = document.getElementById(currentId);
                      const currentColor =
                        currentElement?.getAttribute("ccode");
                      if (currentColor === cc.color) {
                        removeHighLightColor(e);
                      } else {
                        colorBtnPressed(e, cc.color);
                      }
                    }}
                    id={cc.id}
                    type="button"
                    colorcodeOutline={cc.colorCode}
                  ></button>
                );
              }
            })}
          </div>
        </div>
      </Popover.Content>
    </Popover>
  );
  const popoverBrief = (
    // <Popover id="popover-basic" className="outlinePopover">
    <Popover
      id="popover-basic"
      className="outlinePopover"
      // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
      role="dialog"
      // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
      aria-label="Brief note options"
      // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
      onKeyDown={handleOutlinePopoverKeyDown}
    >
      <Popover.Content>
        <div
          className="mLeftTen outLinePopover"
          outlineId={outlineId.current}
          onClick={(e) =>
            AnnotateFromOutline(e, outlineId.current, noteStatus, "brief")
          }
        >
          <span
            tabIndex="0"
            onKeyDown={(e) =>
              handleBriefNote(e, outlineId.current, noteStatus, "brief")
            }
          >
            {noteStatus ? "Edit Brief" : "Add Brief Note"}
          </span>
        </div>
        <div className="mLeftTen outLinePopover">
          <span
            tabIndex="0"
            onKeyDown={(e) => handleChapterJmpToText(e, outlineId.current)}
            onClick={(e) => jumpToTextOutline(e, outlineId.current)}
          >
            {" "}
            Jump to text
          </span>{" "}
        </div>
        <div className="highlighter-colors">
          <div className="highlight-outlinePopover">Change highlight color</div>
          <div className="color-pallete">
            {outlineColorList.map((cc, index) => {
              if (cc.id === "underLineOut") {
                return colorsState.highlightQuickUnderLine ? (
                  <GrFormClose
                    key={index}
                    className="underline_rt"
                    onClick={(e) => removeHighLightColor(e)}
                  />
                ) : (
                  <button
                    data-testid={`brief_${cc.id}`}
                    key={index}
                    className="underline_rt"
                    style={{ background: "" }}
                    aria-label="underLine"
                    colorcode="underLine"
                    title="underLine"
                    onClick={(e) => colorBtnPressedBrief(e, "underLine")}
                    id="underLineOut"
                  >
                    <AiOutlineUnderline />
                  </button>
                );
              } else {
                return (
                  <button
                    data-testid={`brief_${cc.id}`}
                    key={index}
                    className="noButton select-marker colorButton"
                    style={{ background: cc.color }}
                    aria-label={cc.title}
                    title={cc.title}
                    // onClick={(e) =>
                    //   colorsState[cc.stateValue]
                    //     ? removeHighLightColor(e)
                    //     : colorBtnPressedBrief(e, cc.color)
                    // }
                    onClick={(e) => {
                      const currentId =
                        "outline_" + localStorage.getItem("outid");
                      const currentElement = document.getElementById(currentId);
                      const currentColor =
                        currentElement?.getAttribute("ccode");
                      if (currentColor === cc.color) {
                        removeHighLightColor(e);
                      } else {
                        colorBtnPressed(e, cc.color);
                      }
                    }}
                    id={cc.id}
                    type="button"
                    colorcodeOutline={cc.colorCode}
                  ></button>
                );
              }
            })}
          </div>
        </div>
      </Popover.Content>
    </Popover>
  );
  const popoverLink = (
    // <Popover id="popover-basic" className="outlinePopover">
    <Popover
      id="popover-basic"
      className="outlinePopover"
      // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
      role="dialog"
      // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
      aria-label="Link options"
      // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
      onKeyDown={handleOutlinePopoverKeyDown}
    >
      <Popover.Content>
        <div
          className="mLeftTen outLinePopover"
          outlineId={outlineId.current}
          onClick={(e) => EditSharedLink(e, outlineId.current, isSharedLink)}
          tabIndex="0"
          onKeyDown={(e) =>
            handleEditSharedLink(e, outlineId.current, isSharedLink)
          }
        >
          {isSharedLink ? "Edit shared link" : "Edit link"}
        </div>
        <div
          className="mLeftTen outLinePopover"
          outlineId={outlineId.current}
          onClick={(e) => handleSharedLinkFlag(e, outlineId.current)}
          tabIndex="0"
          onKeyDown={(e) => handleSharedLinkFlagonEnter(e, outlineId.current)}
        >
          {isSharedLink ? "Make private" : "Share link"}
        </div>
        <div
          className="mLeftTen outLinePopover"
          outlineId={outlineId.current}
          onClick={(e) =>
            RemoveProfessorLink(e, outlineId.current, isSharedLink)
          }
          tabIndex="0"
          onKeyDown={(e) =>
            handleRemoveProfessorLink(e, outlineId.current, isSharedLink)
          }
        >
          {isSharedLink ? "Remove shared link" : "Remove link"}
        </div>
        <div className="mLeftTen outLinePopover">
          <span
            tabIndex="0"
            onKeyDown={(e) => handleChapterJmpToText(e, outlineId.current)}
            onClick={(e) => jumpToTextOutline(e, outlineId.current)}
          >
            {" "}
            Jump to text
          </span>{" "}
        </div>
      </Popover.Content>
    </Popover>
  );
  const spinnerLabel = (noteStatus) => {
    let label = "";
    if (briefNoteLoading && !noteStatus) {
      label = "Adding brief note to highlight";
    } else if (briefNoteLoading && noteStatus) {
      label = "Saving changes to brief note";
    } else {
      label = "Loading chapter outlines";
    }
    return label;
  };
  const ref = useRef();
  return (
    <React.Fragment>
      <Dialog
        open={notificationsState.notificationOpen}
        onClose={() =>
          setNotificationState({
            notificationOpen: false,
          })
        }
        aria-labelledby="Notification Title"
        aria-describedby="Notofication Description"
      >
        <DialogContent className="notificationHgMsg">
          <DialogContentText
            className="notificationHgMsg1"
            id="alert-dialog-description"
          >
            {notificationsState.notificationContent}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="notificationHgMsg">
          <Button
            className="noHighlightButton"
            onClick={() => setNotificationState({ notificationOpen: false })}
            color="primary"
            autoFocus
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <Spinner
        imageSrc={loaderColors1}
        label={spinnerLabel(noteStatus)}
        overlayBackground="rgba(0,0,0,0.5)"
        loading={loading || briefNoteLoading}
      />
      <div className="iPadMargin">
        <div className="display-inline-block viewingPort_rt mTopTen">
          <div className="display-inline-block viewingLabel_rt">Viewing</div>
          <select
            data-testid="chapterList"
            id="outlineChpaterListDrpDwn"
            value={currentState.currentChapterId}
            aria-label={currentState.currentChapterId}
            className="viewingInput_rt mLeftFive form-control text-box-common display-inline-block"
            onChange={(e) => onChangeChapterEvent(e)}
          >
            {chapterDrpDwnList !== undefined
              ? chapterDrpDwnList.map((option, index) => (
                  <option key={index} value={option.chapterId}>
                    {option.navbarTitle}{" "}
                  </option>
                ))
              : ""}
          </select>
        </div>
        {currentState.currentChapterId &&
        chapterDrpDwnList
          .map((chpt) => chpt.chapterId)
          .indexOf(currentState.currentChapterId) !== -1 ? (
          <div>
            <div className="mTopTen chapterTitlelight_rt">
              {currentState.currentChapterNavTitle}
            </div>
            <div className="jumbToText_rt mTopFive">
              <a
                className="cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={(e) => handleChapterJumpToText(e)}
                tabIndex="0"
                onKeyDown={(e) => handleChapterJumpToTextFunc(e)}
              >
                {" "}
                Jump to Text
              </a>
            </div>
            <div
              aria-live="assertive"
              style={{ position: "absolute", left: "-9999px" }}
            >
              {routeChangeMsg}
            </div>
          </div>
        ) : (
          <div className="pText commonTabInfoTextItalicF14 mTopTwl">
            Select a chapter outline from the dropdown list above.
          </div>
        )}
        <div id="outlineNotesSection">
          {sectionVOList
            ? sectionVOList.map((item, index) => (
                <div
                  key={index}
                  onMouseEnter={() => setAnnotationSectionId(item.sectionId)}
                  sectionId={item.sectionId}
                  id={"outlineSection_" + item.sectionId}
                  className={
                    item.sectionType === "A" || item.sectionType === "-9999"
                      ? "mTopTen sectionTitle"
                      : "mLeftThirty mTopTen sectionTitle"
                  }
                >
                  {item.sectionTitle !== "-9999" ? item.sectionTitle : ""}
                  {item.annotationVOList !== undefined &&
                  item.annotationVOList.length !== 0
                    ? item.annotationVOList.map((annotation, i) => {
                        const stylesForOutlineRv = {
                          backgroundColor:
                            annotation.highlightColorCode == "underline" ||
                            annotation.highlightColorCode == "underLine"
                              ? "white"
                              : annotation.highlightColorCode,
                          textDecoration:
                            annotation.highlightColorCode == "underline" ||
                            annotation.highlightColorCode == "underLine"
                              ? "underline"
                              : "none",
                        };
                        if (
                          annotation.dppContentType === "annotation" &&
                          annotation.highlightText !== "" &&
                          annotation.highlightText !== undefined
                        ) {
                          return (
                            <div
                              key={i}
                              annotationId={annotation.annotationId}
                              id={"outline_" + annotation.annotationId}
                              Ccode={annotation.highlightColorCode}
                              className="annotatedOutlineHighlightCont"
                              noteFlag={
                                annotation.noteText !== undefined
                                  ? "true"
                                  : "false"
                              }
                              style={stylesForOutlineRv}
                            >
                              <div className="row">
                                <div className="col-lg-11 col-md-9 col-sm-8">
                                  <span>{annotation.highlightText}</span>
                                </div>
                                <div
                                  className="col-lg-1 col-md-3 col-sm-4"
                                  style={{ margin: "-6px" }}
                                >
                                  <OverlayTrigger
                                    ref={ref}
                                    trigger="click"
                                    placement="auto"
                                    overlay={popover}
                                    // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
                                    onEntered={focusFirstOutlinePopoverItem}
                                    rootClose
                                  >
                                    <a
                                      data-testid="annotationTag"
                                      id="outlineIcon"
                                      href="javascript:void(0)"
                                      className="fontAwesomeBlackColor"
                                      // 47057 - A11Y: Outline note card menu button does not have an accessible name
                                      role="button"
                                      // 47057 - A11Y: Outline note card menu button does not have an accessible name
                                      aria-label="Annotation Menu"
                                      onClick={() =>
                                        handleMouseHover(
                                          "outline_" + annotation.annotationId,
                                          "annotation",
                                        )
                                      }
                                    >
                                      <FontAwesomeIcon
                                        icon={faEllipsisH}
                                        className="mLeftFive display-inline-block pull-right"
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "24px",
                                        }}
                                      ></FontAwesomeIcon>
                                    </a>
                                  </OverlayTrigger>
                                </div>
                              </div>
                              {annotation.noteText !== undefined ? (
                                <div
                                  className="outline_noteText"
                                  style={{
                                    borderTop: "1px solid #000000",
                                    fontStyle: "italic",
                                    marginTop: "10px",
                                    padding: "10px 10px 0px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {annotation.noteText !== "null"
                                    ? annotation.noteText
                                    : ""}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          );
                        } else if (
                          annotation.dppContentType === "brief" &&
                          annotation.highlightText !== "" &&
                          annotation.highlightText !== undefined
                        ) {
                          return (
                            <div
                              key={i}
                              annotationId={annotation.annotationId}
                              id={"outline_" + annotation.annotationId}
                              Ccode={annotation.highlightColorCode}
                              className="annotatedOutlineHighlightCont"
                              noteFlag={
                                annotation.noteText !== undefined
                                  ? "true"
                                  : "false"
                              }
                              style={stylesForOutlineRv}
                            >
                              <div className="row">
                                <div className="col-lg-11 col-md-9 col-sm-8">
                                  <span>{annotation.highlightText}</span>
                                </div>
                                <div
                                  className="col-lg-1 col-md-3 col-sm-4"
                                  style={{ margin: "-6px" }}
                                >
                                  <OverlayTrigger
                                    ref={ref}
                                    trigger="click"
                                    placement="auto"
                                    overlay={popoverBrief}
                                    // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
                                    onEntered={focusFirstOutlinePopoverItem}
                                    rootClose
                                  >
                                    <a
                                      data-testid="briefTag"
                                      id="outlineIcon"
                                      href="javascript:void(0)"
                                      className="fontAwesomeBlackColor"
                                      // 47057 - A11Y: Outline note card menu button does not have an accessible name
                                      role="button"
                                      // 47057 - A11Y: Outline note card menu button does not have an accessible name
                                      aria-label="Annotation Menu"
                                      onClick={() =>
                                        handleMouseHover(
                                          "outline_" + annotation.annotationId,
                                          "brief",
                                        )
                                      }
                                    >
                                      <FontAwesomeIcon
                                        icon={faEllipsisH}
                                        className="mLeftFive display-inline-block pull-right"
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "24px",
                                        }}
                                      ></FontAwesomeIcon>
                                    </a>
                                  </OverlayTrigger>
                                </div>
                              </div>
                              {annotation.noteText !== undefined ? (
                                <div
                                  className="outline_noteText"
                                  style={{
                                    borderTop: "1px solid #000000",
                                    fontStyle: "italic",
                                    marginTop: "10px",
                                    padding: "10px 10px 0px",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {annotation.noteText !== "null"
                                    ? annotation.noteText
                                    : ""}
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          );
                        } else if (annotation.dppContentType === "link") {
                          return (
                            <div
                              key={i}
                              annotationId={annotation.annotationId}
                              id={"outline_" + annotation.annotationId}
                              linkShareFlag={annotation.linkShareFlag}
                              Cclink={annotation.linkUrl}
                              linkDescription={annotation.linkDescription}
                              className="annotatedOutlineCont"
                            >
                              {userVO1.userRole === "Professor" ? (
                                <OverlayTrigger
                                  ref={ref}
                                  trigger="click"
                                  placement="auto"
                                  overlay={popoverLink}
                                  // 47059 - A11Y: annotation popover does not receive keyboard focus when triggered from the outline
                                  onEntered={focusFirstOutlinePopoverItem}
                                  rootClose
                                >
                                  <a
                                    data-testid="linkTag"
                                    id="outlineIcon"
                                    href="javascript:void(0)"
                                    className="fontAwesomeBlackColor"
                                    // 47057 - A11Y: Outline note card menu button does not have an accessible name
                                    role="button"
                                    // 47057 - A11Y: Outline note card menu button does not have an accessible name
                                    aria-label="Annotation Menu"
                                    onClick={() =>
                                      handleMouseHover(
                                        "outline_" + annotation.annotationId,
                                        "link",
                                      )
                                    }
                                  >
                                    <FontAwesomeIcon
                                      icon={faEllipsisH}
                                      className="mLeftFive display-inline-block pull-right"
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "24px",
                                      }}
                                    ></FontAwesomeIcon>
                                  </a>
                                </OverlayTrigger>
                              ) : null}
                              <div className="annotationLink">
                                {annotation.linkShareFlag === "true" ? (
                                  <i
                                    className="fa fa-users"
                                    style={{ padding: "5px", fontSize: "14px" }}
                                    aria-hidden="true"
                                  ></i>
                                ) : null}
                                <span
                                  onClick={() =>
                                    onHandleClickLink(annotation.linkUrl)
                                  }
                                  className="profLinkUrl"
                                >
                                  {annotation.linkUrl}
                                </span>
                                <a
                                  className="annotationLinkIcon"
                                  href={
                                    String(annotation.linkUrl).startsWith(
                                      "http://",
                                    ) ||
                                    String(annotation.linkUrl).startsWith(
                                      "https://",
                                    )
                                      ? annotation.linkUrl
                                      : "http://" + annotation.linkUrl
                                  }
                                  target="_blank"
                                >
                                  <i
                                    className="fa fa-external-link"
                                    style={{
                                      color: "#000000",
                                      padding: "5px",
                                      fontSize: "14px",
                                    }}
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </div>
                            </div>
                          );
                        }
                      })
                    : ""}
                </div>
              ))
            : ""}
        </div>
      </div>
    </React.Fragment>
  );
}
export default withRouter(NoteBookListOutline);
